import React from 'react'
export const HandShakeIcon = () => (
  <svg
    width="81"
    height="70"
    viewBox="0 0 81 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.1257 0.657219C38.7423 1.10799 37.2501 2.28931 36.7838 3.3152L36.6128 3.68825L36.0532 3.20639C35.7579 2.94215 35.1206 2.53801 34.6387 2.3204C33.9237 1.97844 33.5662 1.91626 32.3849 1.91626C31.1103 1.91626 30.8771 1.96289 29.9445 2.42921C28.0793 3.34628 26.9601 5.00946 26.7581 7.21667L26.6648 8.18038L25.6078 8.24256C22.7633 8.44463 20.5095 10.7917 20.4473 13.6051L20.4162 14.5533L19.3282 14.6155C17.3386 14.7243 15.6909 15.7813 14.7428 17.5688C14.292 18.4081 14.1987 18.7346 14.1521 19.8848L14.0899 21.2371L13.0485 21.2993C11.7428 21.3925 10.7014 21.8744 9.69107 22.9003C8.46311 24.1127 8.13669 24.921 8.13669 26.7862C8.13669 29.1022 8.40094 29.5996 11.3542 32.5529L13.7013 34.9156L13.5925 35.5995C13.4526 36.4855 12.862 37.729 12.349 38.1953L11.9449 38.5839L11.3542 38.0088C10.3439 37.0295 9.22475 36.7497 7.84136 37.1539C7.32842 37.2938 6.6445 37.9 4.28185 40.216C0.629081 43.8221 0.256032 44.4905 0.784518 46.3558C0.939956 46.8998 2.46324 48.5008 12.0071 58.0757C19.4214 65.5056 23.2607 69.2517 23.696 69.4537C24.5042 69.8579 25.6545 69.8579 26.4627 69.4537C27.3176 69.0496 32.8357 63.5005 33.1621 62.7388C33.675 61.4953 33.3641 60.0498 32.3538 59.0084L31.7787 58.4177L32.1517 58.0291C32.3538 57.8115 32.8978 57.454 33.3641 57.2208C34.1102 56.8633 34.4677 56.8011 36.4884 56.6923C37.7319 56.6302 39.2086 56.5058 39.7682 56.397C40.4676 56.2882 41.6334 56.2727 43.5764 56.3659C46.6851 56.5214 47.4467 56.7234 48.426 57.6716L48.9234 58.1534L48.3794 58.7752C48.0685 59.1016 47.7265 59.6146 47.6022 59.9099C47.3069 60.6249 47.3379 61.7907 47.6799 62.5368C48.0374 63.2829 53.7886 69.0496 54.4259 69.2828C55.1409 69.5625 56.4932 69.4848 57.146 69.1584C57.4724 68.9874 62.6174 63.9357 68.7883 57.7649C80.6015 45.9205 80.1818 46.4024 80.1818 44.8947C80.1663 43.8377 79.6689 43.1848 76.5135 40.045C73.84 37.4181 73.327 36.9674 72.7208 36.8119C71.524 36.4855 70.1095 36.9518 69.1458 37.9622L68.7727 38.3818L67.5603 37.1694L66.3634 35.9726L67.5137 34.7757C68.8038 33.4078 69.1768 32.7861 69.4566 31.4649C69.9851 28.8846 68.4774 26.2733 65.9282 25.3717L65.1355 25.092L65.8816 24.2681C66.7831 23.2889 67.2494 22.3718 67.436 21.206C67.7157 19.4807 67.1251 17.7242 65.8505 16.4963C65.2132 15.8901 63.7366 15.0507 63.2547 15.0507C63.1304 15.0507 63.3946 14.6621 63.8454 14.1958C65.0267 12.9523 65.4774 11.8642 65.4774 10.3099C65.4774 8.66224 64.949 7.43428 63.7521 6.34622C62.5708 5.2737 61.5138 4.90066 59.804 4.97838C58.6382 5.04055 58.3584 5.10272 57.4414 5.61567L56.3844 6.19079L56.2445 5.75556C55.8093 4.57424 55.4984 4.07684 54.659 3.3152C53.6642 2.38258 52.3119 1.83855 51.0373 1.83855C50.0425 1.83855 48.597 2.35149 47.6644 3.00433C46.9027 3.54836 46.8405 3.57944 46.6851 3.29965C46.281 2.5691 44.9442 1.34115 44.1515 0.968094C43.0945 0.470695 41.1515 0.315262 40.1257 0.657219ZM43.1411 3.09759C43.9028 3.47063 44.6955 4.34108 44.882 5.02501C45.0064 5.46023 44.9287 5.56904 43.3587 7.1545L41.7111 8.83322L40.1257 7.24776C39.1153 6.25296 38.5247 5.53795 38.5247 5.33588C38.5247 4.90066 39.3485 3.62608 39.7992 3.36183C40.965 2.69345 42.1153 2.60019 43.1411 3.09759ZM33.4574 4.35663C33.9859 4.51206 34.7475 5.19599 37.8563 8.27364C39.9391 10.3254 41.7422 12.2528 41.8821 12.5482C42.364 13.5274 42.3329 14.5378 41.8355 15.517C40.9028 17.3356 38.7889 17.8797 37.1102 16.7605C36.1931 16.1543 29.7735 9.67258 29.416 8.98866C29.0119 8.21147 29.043 6.7659 29.4782 5.92654C30.2243 4.51206 31.8098 3.87477 33.4574 4.35663ZM52.3586 4.51206C53.4466 5.07164 53.9596 5.84882 54.0373 7.03015C54.0839 7.74516 54.0217 8.1493 53.8352 8.53789C53.6953 8.83322 52.2808 10.372 50.6954 11.9575C48.1618 14.5067 47.8353 14.8953 47.8198 15.3616C47.8043 15.9522 48.4105 16.6051 48.97 16.6051C49.2032 16.6051 50.7576 15.1751 53.8197 12.1129C58.7626 7.21667 58.7937 7.18559 60.4413 7.30993C62.3687 7.44983 63.5967 9.22181 63.0682 11.1337C62.8972 11.7865 62.4153 12.3306 58.374 16.403C54.3482 20.4599 53.8663 21.004 53.8663 21.4392C53.8663 22.1076 54.5502 22.7293 55.1409 22.5894C55.374 22.5428 56.5243 21.5169 57.8766 20.1801C60.2392 17.8486 60.7211 17.4911 61.7003 17.3045C62.8506 17.0869 64.3117 17.8641 64.9023 18.9988C65.2443 19.6516 65.2288 21.0506 64.8868 21.7345C64.7314 22.0298 63.5656 23.32 62.3065 24.6101C60.9698 25.9624 59.9439 27.1126 59.8973 27.3458C59.8195 27.6411 59.8973 27.8743 60.177 28.1852C60.6278 28.7292 61.3739 28.7758 61.8869 28.3095C63.2236 27.066 65.0422 27.0815 66.2857 28.325C67.3271 29.3665 67.5137 30.6411 66.8142 31.9934C66.5189 32.5529 50.4311 48.6873 49.0167 49.8376C45.5504 52.6354 40.6231 54.3763 36.1465 54.3763C33.846 54.3763 32.1051 54.967 30.7373 56.1949L30.1155 56.7701L21.8929 48.5474L13.6703 40.3248L14.0588 39.8429C14.8205 38.9259 15.3801 37.9622 15.5666 37.3093C15.7531 36.6098 15.8308 36.5632 16.3127 36.8275C16.4837 36.9052 17.0432 37.0606 17.5717 37.1383C19.266 37.4181 21.038 36.8275 22.3436 35.5684C22.9809 34.9467 23.9136 33.2679 23.9136 32.7395C23.9136 32.5374 24.069 32.584 24.7685 33.0037C26.9912 34.3405 29.6803 34.0607 31.5922 32.3042C32.3227 31.6203 33.2398 30.0193 33.2398 29.4131V29.0556L34.2501 29.5219C38.0739 31.325 42.2551 28.667 42.2551 24.4547C42.2551 22.8847 41.8355 21.8278 40.7629 20.662C40.2966 20.1646 39.9236 19.7138 39.9236 19.6827C39.9236 19.6361 40.2189 19.5273 40.592 19.4185C42.1308 18.9677 43.3743 17.8641 44.0893 16.3097C44.4468 15.5792 44.509 15.2217 44.509 14.0248C44.509 12.7036 44.4779 12.5326 43.9494 11.5067L43.3898 10.4187L46.2032 7.60527C49.1721 4.6675 49.8405 4.18565 51.0373 4.1701C51.3948 4.1701 51.97 4.32554 52.3586 4.51206ZM27.3021 10.7762C28.0171 11.0715 39.1775 22.1542 39.6283 23.0091C40.0168 23.7707 40.0168 25.123 39.6283 25.9002C39.0531 27.0038 37.8718 27.7966 36.7838 27.7966C35.4315 27.7966 35.2138 27.6411 31.359 23.8174C28.1259 20.5998 27.6441 20.1801 27.2088 20.1801C26.5715 20.1801 26.0897 20.662 26.0897 21.2993C26.0897 21.719 26.385 22.092 28.2503 23.9728C30.5041 26.2733 30.8305 26.724 31.0015 27.781C31.2968 29.6152 29.6958 31.5271 27.8617 31.5271C26.3695 31.5271 26.3073 31.4649 21.5354 26.724C19.0484 24.2526 16.9033 22.0143 16.7324 21.6723C16.0329 20.3045 16.5148 18.3926 17.8204 17.4755C18.3489 17.1025 18.6909 16.9937 19.4681 16.947C20.6649 16.8693 21.24 17.1336 22.6545 18.3926C23.4939 19.1387 23.7115 19.2631 24.0535 19.1698C24.6752 19.0144 25.0016 18.6413 25.0016 18.0506C25.0016 17.631 24.8151 17.3356 24.0068 16.4652C22.5768 14.8953 22.3592 13.6829 23.2296 12.144C24.0224 10.7451 25.7944 10.1544 27.3021 10.7762ZM15.0226 23.8329C15.7065 24.1282 20.6649 28.9779 21.1934 29.895C22.0172 31.2939 21.7841 32.8794 20.6028 33.9674C19.6546 34.8379 18.6753 35.071 17.4318 34.7135C16.5769 34.4648 16.3749 34.2938 13.7013 31.6359C11.9294 29.8483 10.7791 28.5893 10.6392 28.2318C10.0019 26.7396 10.5304 24.9987 11.8516 24.0972C12.4889 23.6775 12.7376 23.5998 13.5148 23.5998C14.0278 23.5998 14.6961 23.7086 15.0226 23.8329ZM65.4153 41.7237C63.9697 43.1848 63.7055 43.5268 63.7055 43.9309C63.7055 44.5838 64.1873 45.0501 64.8402 45.0501C65.2909 45.0501 65.6484 44.7392 68.1354 42.2367C70.9644 39.4077 71.5861 38.8948 72.068 39.0502C72.2234 39.1124 73.5757 40.387 75.099 41.9103C77.1508 43.9776 77.8502 44.7703 77.8502 45.0501C77.8502 45.3454 75.3943 47.8946 67.0163 56.2727C57.4413 65.8476 56.1201 67.1222 55.7005 67.1222C55.2963 67.1222 54.83 66.718 52.4674 64.3554C50.1358 62.0238 49.7161 61.5264 49.7161 61.1378C49.7161 60.7337 50.571 59.8166 56.1979 54.1898C62.0423 48.3454 62.664 47.6614 62.664 47.2107C62.664 46.5889 62.1666 46.1382 61.4827 46.1382C61.0475 46.1382 60.3947 46.7444 55.8404 51.2831L50.6798 56.4281L49.856 55.7753C49.0322 55.1069 47.882 54.5162 47.0115 54.3141C46.5918 54.2053 46.6385 54.1743 47.9286 53.3971C50.0581 52.138 51.6746 50.6769 58.4206 43.8999L64.7158 37.5891L65.9127 38.786L67.1251 39.9828L65.4153 41.7237ZM20.2142 50.1329C29.7269 59.6456 31.0637 61.029 31.0637 61.4487C31.0637 61.8373 30.644 62.3192 28.2969 64.6663C25.9653 67.0134 25.4679 67.433 25.0793 67.433C24.6752 67.433 23.2452 66.0652 13.7791 56.5835C4.34403 47.164 2.92955 45.6874 2.92955 45.2988C2.92955 44.9102 3.36477 44.3973 5.69633 42.0657C8.02789 39.7341 8.54083 39.2989 8.91388 39.2989C9.31802 39.2989 10.8102 40.7289 20.2142 50.1329Z"
      fill="#FEFEFF"
    />
  </svg>
)

export const InvestIcon = () => (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_372_10548)">
      <path
        d="M100 183.334C146.024 183.334 183.334 146.024 183.334 100C183.334 53.9766 146.024 16.667 100 16.667C53.9766 16.667 16.667 53.9766 16.667 100C16.667 146.024 53.9766 183.334 100 183.334Z"
        fill="url(#paint0_linear_372_10548)"
      />
      <g filter="url(#filter0_f_372_10548)">
        <path
          d="M100 160.87C133.618 160.87 160.87 133.618 160.87 100C160.87 66.3831 133.618 39.1309 100 39.1309C66.3831 39.1309 39.1309 66.3831 39.1309 100C39.1309 133.618 66.3831 160.87 100 160.87Z"
          fill="url(#paint1_linear_372_10548)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.2729 32.3044C95.6671 32.3044 96.7975 31.1742 96.7975 29.78C96.7975 28.3859 95.6671 27.2556 94.2729 27.2556C92.8787 27.2556 91.7489 28.3859 91.7489 29.78C91.7489 31.1742 92.8787 32.3044 94.2729 32.3044ZM94.2729 34.1977C96.7127 34.1977 98.691 32.2198 98.691 29.78C98.691 27.3402 96.7127 25.3623 94.2729 25.3623C91.833 25.3623 89.8555 27.3402 89.8555 29.78C89.8555 32.2198 91.833 34.1977 94.2729 34.1977Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.1276 148.247C35.5218 148.247 36.6521 147.116 36.6521 145.722C36.6521 144.328 35.5218 143.198 34.1276 143.198C32.7335 143.198 31.6033 144.328 31.6033 145.722C31.6033 147.116 32.7335 148.247 34.1276 148.247ZM34.1276 150.14C36.5675 150.14 38.5454 148.162 38.5454 145.722C38.5454 143.282 36.5675 141.305 34.1276 141.305C31.6879 141.305 29.71 143.282 29.71 145.722C29.71 148.162 31.6879 150.14 34.1276 150.14Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M172.535 142.449C173.929 142.449 175.059 141.318 175.059 139.924C175.059 138.53 173.929 137.4 172.535 137.4C171.14 137.4 170.011 138.53 170.011 139.924C170.011 141.318 171.14 142.449 172.535 142.449ZM172.535 144.342C174.974 144.342 176.953 142.364 176.953 139.924C176.953 137.484 174.974 135.507 172.535 135.507C170.095 135.507 168.117 137.484 168.117 139.924C168.117 142.364 170.095 144.342 172.535 144.342Z"
        fill="white"
      />
      <path
        d="M53.1815 43.615C53.3671 42.8458 54.4613 42.8458 54.6469 43.615L55.2719 46.2038C55.3382 46.4787 55.5529 46.6933 55.8277 46.7597L58.4166 47.3846C59.1858 47.5703 59.1858 48.6644 58.4166 48.8501L55.8277 49.475C55.5529 49.5414 55.3382 49.7559 55.2719 50.0309L54.6469 52.6197C54.4613 53.3889 53.3671 53.3889 53.1815 52.6197L52.5566 50.0309C52.4902 49.7559 52.2756 49.5414 52.0007 49.475L49.4119 48.8501C48.6427 48.6644 48.6427 47.5703 49.4119 47.3846L52.0007 46.7597C52.2756 46.6933 52.4902 46.4787 52.5566 46.2038L53.1815 43.615Z"
        fill="white"
      />
      <path
        d="M160.359 156.95C160.563 156.108 161.762 156.108 161.966 156.95L162.651 159.788C162.723 160.09 162.958 160.325 163.26 160.398L166.098 161.083C166.94 161.286 166.94 162.485 166.098 162.689L163.26 163.374C162.958 163.447 162.723 163.682 162.651 163.983L161.966 166.821C161.762 167.664 160.563 167.664 160.359 166.821L159.674 163.983C159.601 163.682 159.366 163.447 159.065 163.374L156.227 162.689C155.384 162.485 155.384 161.286 156.227 161.083L159.065 160.398C159.366 160.325 159.601 160.09 159.674 159.788L160.359 156.95Z"
        fill="url(#paint2_linear_372_10548)"
      />
      <path
        d="M41.3271 167.563C42.2865 167.41 43.0525 168.352 42.7058 169.26L40.366 175.387C40.0193 176.295 38.82 176.487 38.2073 175.732L34.0711 170.642C33.4583 169.889 33.8916 168.754 34.851 168.6L41.3271 167.563Z"
        fill="url(#paint3_linear_372_10548)"
      />
      <path
        d="M164.478 50.0051C164.238 49.0636 165.107 48.2153 166.042 48.4782L172.357 50.2525C173.292 50.5153 173.592 51.6922 172.897 52.3709L168.203 56.9519C167.508 57.6305 166.339 57.3019 166.098 56.3604L164.478 50.0051Z"
        fill="url(#paint4_linear_372_10548)"
      />
      <path
        d="M143.454 93.9937L129.764 96.6553C125.868 97.4118 123.324 101.184 124.082 105.079C124.839 108.973 128.61 111.517 132.505 110.76L146.196 108.099C150.091 107.342 152.635 103.571 151.877 99.6756C151.121 95.7807 147.349 93.2365 143.454 93.9937Z"
        fill="url(#paint5_linear_372_10548)"
      />
      <path
        d="M148.834 101.018C148.903 99.2445 147.522 97.751 145.748 97.6822C143.975 97.6126 142.482 98.9945 142.413 100.768C142.343 102.541 143.725 104.034 145.498 104.104C147.272 104.173 148.766 102.791 148.834 101.018Z"
        fill="#EBEBEB"
      />
      <path
        d="M145.958 102.619C146.911 102.434 147.534 101.51 147.349 100.558C147.163 99.6039 146.24 98.9815 145.287 99.1663C144.334 99.3518 143.71 100.275 143.896 101.229C144.081 102.181 145.005 102.805 145.958 102.619Z"
        fill="#DBDBDB"
      />
      <path
        d="M121.747 72.3549L51.8416 85.9434C47.9131 86.7065 45.3474 90.5108 46.1111 94.4391L55.5561 143.029C56.3197 146.958 60.1234 149.523 64.0519 148.759L133.957 135.172C137.886 134.408 140.451 130.604 139.688 126.675L130.243 78.0855C129.48 74.1572 125.676 71.5913 121.747 72.3549Z"
        fill="url(#paint6_linear_372_10548)"
      />
      <path
        d="M120.47 50.2596L134.749 87.1695C135.549 89.2326 134.521 91.5529 132.462 92.3507L73.9233 114.998C71.8636 115.796 69.5433 114.769 68.7438 112.706L54.4644 75.7956C53.7232 73.8753 54.6754 71.7176 56.5962 70.9765L115.649 48.1323C117.57 47.3912 119.727 48.3434 120.468 50.2642L120.47 50.2596Z"
        fill="url(#paint7_linear_372_10548)"
      />
      <path
        d="M123.219 85.6493C123.951 87.5471 123.01 89.6812 121.112 90.413C119.215 91.1457 117.08 90.2036 116.348 88.3058C115.615 86.4087 116.558 84.2746 118.455 83.542C120.352 82.8102 122.487 83.7522 123.219 85.6493Z"
        fill="url(#paint8_linear_372_10548)"
      />
      <path
        d="M127.448 84.01C128.181 85.9079 127.239 88.0419 125.342 88.7745C123.444 89.5064 121.31 88.5644 120.577 86.6673C119.845 84.7695 120.787 82.6354 122.684 81.9035C124.582 81.1709 126.716 82.1129 127.448 84.01Z"
        fill="url(#paint9_linear_372_10548)"
      />
      <path
        d="M72.1074 72.2609L62.5166 75.9711C61.7434 76.2704 61.359 77.1399 61.6582 77.9131L63.888 83.6769C64.1871 84.4501 65.0566 84.8348 65.8298 84.5356L75.4203 80.8247C76.1942 80.5262 76.5782 79.6566 76.279 78.8834L74.0492 73.1196C73.75 72.3462 72.8804 71.9618 72.1074 72.2609Z"
        fill="url(#paint10_linear_372_10548)"
      />
      <path
        d="M115.76 60.7703L110.152 62.9382C108.855 63.4365 107.398 62.7935 106.896 61.4967C106.398 60.1985 107.041 58.7419 108.338 58.2402L113.945 56.0723C115.242 55.5707 116.7 56.2171 117.202 57.5139C117.7 58.812 117.057 60.2687 115.76 60.7703Z"
        fill="white"
      />
      <path
        d="M66.9935 93.0551L66.6016 93.55C66.6016 93.55 66.5692 93.5855 66.5459 93.5942C66.4991 93.6123 66.4488 93.6007 66.416 93.5754C66.3537 93.5225 66.3455 93.4413 66.3974 93.387L66.9288 92.6971C66.974 92.6449 67.0651 92.6333 67.1169 92.6783C67.1451 92.7022 67.16 92.7304 67.1695 92.7652L68.4476 96.0652C68.4732 96.1319 68.445 96.208 68.3716 96.2362C68.3048 96.2616 68.2263 96.2268 68.2007 96.1602L67.0001 93.0522L66.9935 93.0551Z"
        fill="#F8F8F8"
      />
      <path
        d="M69.2866 95.6283L70.3776 93.4631C70.5062 93.1993 70.5181 92.9116 70.4195 92.6544C70.3349 92.4341 70.167 92.2464 69.9389 92.1305C69.6819 92 69.3885 91.9935 69.1396 92.0928C68.9126 92.1805 68.7219 92.3413 68.6031 92.5711L68.4911 92.7979C68.4603 92.8667 68.3756 92.8957 68.3163 92.8609C68.247 92.8297 68.2183 92.7457 68.253 92.6863L68.3638 92.4558C68.5138 92.1689 68.7611 91.9551 69.0448 91.8464C69.3584 91.7254 69.7216 91.724 70.0564 91.8979C70.3537 92.0442 70.5614 92.2863 70.6677 92.5631C70.7894 92.8805 70.7856 93.2493 70.6196 93.5848L69.6855 95.4406L71.3874 94.787C71.4528 94.758 71.5301 94.7899 71.5583 94.8631C71.5838 94.9297 71.5489 95.0087 71.4822 95.0341L69.4792 95.8102L69.4592 95.8182C69.4225 95.8326 69.3819 95.8363 69.3517 95.8174C69.2832 95.7783 69.2537 95.7015 69.2846 95.6327L69.2866 95.6283Z"
        fill="#F8F8F8"
      />
      <path
        d="M73.2742 90.4666L72.7148 91.7804C72.959 91.7405 73.217 91.7637 73.4575 91.8709C73.7851 92.0166 74.0256 92.284 74.1459 92.5978C74.2662 92.9115 74.2699 93.2702 74.1206 93.5992C73.9749 93.9275 73.7083 94.1709 73.3959 94.2948C73.0894 94.4122 72.7307 94.4159 72.4015 94.2666C72.3335 94.2391 72.2995 94.1608 72.3324 94.0869C72.3586 94.0151 72.4387 93.9847 72.5126 94.0173C72.7735 94.1282 73.0525 94.1282 73.2996 94.0333C73.5467 93.9383 73.7575 93.7499 73.8764 93.4905C73.993 93.2267 73.9887 92.9456 73.8938 92.6985C73.7988 92.4514 73.6112 92.2405 73.3503 92.1304C73.0901 92.0115 72.809 92.0166 72.5619 92.1108C72.522 92.1267 72.4771 92.1202 72.4391 92.1006L72.4325 92.1035C72.3598 92.0738 72.3278 91.9905 72.362 91.9195L72.8996 90.6564L71.5213 91.1854C71.4491 91.2173 71.3706 91.1825 71.3438 91.1122C71.3156 91.0391 71.3505 90.9601 71.4206 90.9333L73.1025 90.2876C73.1742 90.2564 73.2532 90.2912 73.28 90.3615C73.288 90.3811 73.2887 90.4043 73.2851 90.4246C73.2851 90.4434 73.28 90.4608 73.2735 90.4746L73.2742 90.4666Z"
        fill="#F8F8F8"
      />
      <path
        d="M77.3076 91.9282L75.3619 92.6825L75.3452 92.689C75.3184 92.6992 75.2858 92.7042 75.2583 92.6919C75.1858 92.6738 75.1474 92.5926 75.175 92.5245L76.2539 89.1318L76.2576 89.1224C76.2829 89.0477 76.3503 89.0144 76.425 89.039C76.451 89.0484 76.4706 89.068 76.488 89.084C76.4916 89.0941 76.501 89.0977 76.5025 89.1013L76.509 89.118L77.4619 91.5818L77.7025 91.489C77.7757 91.4615 77.8547 91.4963 77.88 91.5629C77.9054 91.6296 77.8706 91.7079 77.8003 91.7347L77.5605 91.8274L77.7974 92.4448C77.8228 92.5115 77.788 92.5897 77.7177 92.6166C77.651 92.6426 77.5728 92.6071 77.5467 92.5405L77.3097 91.9231L77.3076 91.9282ZM77.2134 91.6811L76.3981 89.5782L75.5141 92.3412L77.2155 91.6876L77.2134 91.6811Z"
        fill="#F8F8F8"
      />
      <path
        d="M81.9592 90.5711C81.8867 90.5414 81.8548 90.458 81.8903 90.3906C81.9215 90.3218 82.0034 90.2863 82.0737 90.3203C82.3345 90.4312 82.6142 90.4312 82.8606 90.3363C83.1077 90.2414 83.3121 90.0558 83.4294 89.7928C83.5468 89.529 83.5432 89.2508 83.4483 89.0044C83.3526 88.7537 83.1642 88.5428 82.9055 88.4276C82.6483 88.316 82.3657 88.3174 82.1186 88.4116C81.8679 88.508 81.6606 88.695 81.5432 88.958C81.5121 89.0276 81.4287 89.0595 81.3628 89.0276C81.3425 89.024 81.3258 89.0109 81.3179 88.9986L81.315 88.9921C81.315 88.9921 81.3048 88.9848 81.3019 88.9783C81.2918 88.9703 81.2852 88.9537 81.2802 88.9406C81.2773 88.9341 81.2765 88.9225 81.2729 88.9124L80.886 87.3957C80.8708 87.3558 80.878 87.3145 80.9005 87.2834C80.9128 87.2551 80.9389 87.2341 80.9722 87.2211L82.6476 86.5783C82.7193 86.5464 82.7976 86.5812 82.8251 86.6515C82.8541 86.7283 82.8179 86.8037 82.7483 86.8305L81.1794 87.4327L81.465 88.5558C81.6063 88.3747 81.7947 88.2377 82.0121 88.1544C82.3258 88.0341 82.6751 88.0261 83.0084 88.1776C83.3432 88.3211 83.5744 88.5841 83.6976 88.9044C83.815 89.2116 83.828 89.5747 83.6751 89.9051C83.528 90.229 83.2584 90.4747 82.9483 90.5935C82.6345 90.7138 82.2758 90.7174 81.9483 90.5718L81.9592 90.5711Z"
        fill="#F8F8F8"
      />
      <path
        d="M84.4333 86.7931C84.513 86.2612 84.8021 85.7786 85.3905 85.5257C85.455 85.4938 85.5333 85.5286 85.5659 85.5931C85.5934 85.6662 85.5587 85.7445 85.4934 85.7735C84.9971 85.9873 84.7804 86.3691 84.6963 86.83C84.6536 87.0873 84.671 87.3721 84.7195 87.6481C84.842 87.3177 85.0971 87.0358 85.4514 86.9003C86.1152 86.6452 86.8492 86.9721 87.1007 87.6264C87.3529 88.2836 87.0289 89.0163 86.3695 89.2735C85.726 89.5206 85.0072 89.2148 84.7391 88.5865C84.7 88.5134 84.6703 88.4365 84.6384 88.3532C84.4587 87.8749 84.3543 87.3134 84.4369 86.7916L84.4333 86.7931ZM84.9818 88.4699C84.992 88.4967 85.0065 88.5141 85.0174 88.5329C85.0239 88.5496 85.0275 88.5597 85.0246 88.572C85.2637 89.0054 85.7963 89.2061 86.2674 89.0257C86.7913 88.825 87.0485 88.2394 86.8514 87.7257C86.6543 87.2119 86.0688 86.9539 85.5449 87.1554C85.0311 87.3525 84.7732 87.9373 84.971 88.4518L84.9782 88.4713L84.9818 88.4699Z"
        fill="#F8F8F8"
      />
      <path
        d="M88.8 88.1348L88.9087 84.4674L87.1696 85.1348C87.1044 85.163 87.0268 85.1319 87.0015 85.0652C86.9761 84.9985 87.0109 84.9195 87.0776 84.8942L88.9797 84.1638C89.0022 84.1435 89.0261 84.1348 89.0565 84.1348C89.0928 84.1398 89.1312 84.1594 89.1529 84.1855C89.166 84.2 89.1732 84.2087 89.1783 84.2217C89.1884 84.2485 89.1892 84.271 89.1834 84.2964L89.071 88.1413C89.0689 88.1956 89.0334 88.2442 88.987 88.2616C88.9667 88.2695 88.9565 88.2732 88.9326 88.271C88.8594 88.2688 88.8 88.2036 88.7964 88.1355L88.8 88.1348Z"
        fill="#F8F8F8"
      />
      <path
        d="M91.0256 83.3391C91.4365 83.1818 91.9046 83.3847 92.0625 83.7949C92.1582 84.0456 92.1183 84.3094 91.9886 84.5203C92.4821 84.5297 92.9437 84.8347 93.1299 85.3188C93.3785 85.9659 93.0611 86.6855 92.4147 86.9369C91.7705 87.1847 91.0481 86.8681 90.7966 86.2224C90.6104 85.7384 90.7466 85.2036 91.0988 84.8659C90.8662 84.7978 90.6625 84.6275 90.5669 84.3768C90.4089 83.9666 90.6067 83.5036 91.0241 83.3434L91.0256 83.3391ZM92.322 86.6855C92.8357 86.4884 93.0807 85.9195 92.8865 85.4123C92.693 84.9087 92.127 84.6507 91.6125 84.8485C91.1053 85.0427 90.8553 85.6174 91.0488 86.1217C91.2444 86.6318 91.8147 86.8804 92.322 86.6855ZM91.5111 84.5927C91.785 84.4797 91.9249 84.1659 91.8191 83.8884C91.7125 83.6116 91.4009 83.4782 91.1241 83.5847C90.8473 83.6913 90.7125 83.9992 90.8191 84.2761C90.9256 84.5529 91.2357 84.6942 91.514 84.5913L91.5111 84.5927Z"
        fill="#F8F8F8"
      />
      <path
        d="M97.4131 80.8684C98.0305 80.6315 98.7052 80.8938 98.9987 81.4583C99.0088 81.4663 99.0117 81.4728 99.0189 81.4815C99.0624 81.5757 99.1059 81.6779 99.1465 81.7844C99.3298 82.2619 99.4334 82.8308 99.3574 83.3503C99.274 83.8721 98.982 84.367 98.4001 84.617L98.3936 84.6199C98.3204 84.6481 98.2443 84.6199 98.2182 84.5532C98.1907 84.4793 98.2197 84.4068 98.2907 84.3721C98.7791 84.1576 99.011 83.7742 99.0878 83.3155C99.1276 83.0518 99.1197 82.7713 99.0646 82.4974C98.9421 82.8279 98.6827 83.0996 98.3226 83.238C97.6682 83.4887 96.9349 83.1735 96.6762 82.5105C96.4255 81.8568 96.7523 81.1221 97.4066 80.8713L97.4131 80.8684ZM98.8095 81.6844C98.6124 81.1706 98.0327 80.9177 97.5088 81.1192C96.995 81.3163 96.7363 81.8981 96.932 82.409C97.1334 82.9329 97.7146 83.18 98.2284 82.9829C98.7523 82.7822 99.011 82.2083 98.8059 81.6851L98.8095 81.6844Z"
        fill="#F8F8F8"
      />
      <path
        d="M100.214 81.853C100.029 81.3697 99.9797 80.8827 100.071 80.461C100.168 80.0566 100.397 79.716 100.761 79.5762C101.125 79.4363 101.526 79.5349 101.868 79.7675C102.213 80.0182 102.516 80.4073 102.705 80.8899C102.891 81.3733 102.93 81.8639 102.839 82.2776C102.743 82.6856 102.515 83.0298 102.151 83.1697C101.788 83.3088 101.386 83.2102 101.042 82.9711C100.696 82.7291 100.399 82.3341 100.213 81.8501L100.214 81.853ZM100.464 81.7573C100.634 82.1979 100.907 82.5486 101.2 82.7537C101.491 82.9559 101.799 83.0182 102.056 82.9189C102.312 82.8204 102.491 82.5682 102.577 82.2218C102.654 81.874 102.625 81.4298 102.456 80.9892C102.287 80.5486 102.007 80.2001 101.717 79.9936C101.419 79.7834 101.119 79.7298 100.862 79.8283C100.604 79.9269 100.415 80.1718 100.341 80.5262C100.264 80.8733 100.299 81.3153 100.47 81.7595L100.464 81.7573Z"
        fill="#F8F8F8"
      />
      <path
        d="M103.811 78.8135L103.419 79.3092C103.419 79.3092 103.387 79.3439 103.364 79.3534C103.317 79.3715 103.267 79.3599 103.233 79.3345C103.171 79.2816 103.163 79.2005 103.215 79.1461L103.746 78.4555C103.792 78.4041 103.882 78.3918 103.935 78.4374C103.963 78.4606 103.977 78.4896 103.987 78.5244L105.265 81.8237C105.29 81.891 105.262 81.9664 105.189 81.9947C105.122 82.0208 105.044 81.9852 105.018 81.9186L103.818 78.8113L103.811 78.8135Z"
        fill="#F8F8F8"
      />
      <path
        d="M106.103 81.3852L107.194 79.2207C107.323 78.957 107.335 78.6686 107.236 78.412C107.151 78.1917 106.984 78.0033 106.756 77.8881C106.498 77.757 106.205 77.7512 105.956 77.8504C105.73 77.9374 105.54 78.1019 105.419 78.328L105.308 78.5548C105.277 78.6244 105.192 78.6526 105.133 78.6178C105.064 78.5874 105.035 78.5026 105.069 78.4432L105.18 78.2135C105.33 77.9258 105.577 77.712 105.86 77.5997C106.174 77.4794 106.537 77.478 106.872 77.6519C107.169 77.7983 107.377 78.0403 107.483 78.3171C107.605 78.6338 107.601 79.0033 107.435 79.3388L106.501 81.1946L108.203 80.541C108.268 80.512 108.347 80.5468 108.374 80.6171C108.399 80.6838 108.364 80.762 108.298 80.7881L106.295 81.5642L106.274 81.5722C106.238 81.5859 106.197 81.5903 106.167 81.5715C106.098 81.5323 106.069 81.4555 106.1 81.3867L106.103 81.3852Z"
        fill="#F8F8F8"
      />
      <path
        d="M113.169 75.034L112.609 76.3485C112.854 76.3079 113.112 76.3311 113.352 76.4383C113.68 76.584 113.921 76.8514 114.041 77.1651C114.161 77.4789 114.165 77.8376 114.016 78.1666C113.869 78.4948 113.603 78.7383 113.294 78.8608C112.987 78.9789 112.625 78.984 112.296 78.8347C112.228 78.8072 112.194 78.7282 112.227 78.6543C112.255 78.5861 112.333 78.5521 112.407 78.5847C112.668 78.6956 112.947 78.6956 113.194 78.6006C113.441 78.5057 113.652 78.3173 113.771 78.0579C113.888 77.7948 113.883 77.513 113.789 77.2659C113.694 77.0195 113.505 76.8079 113.244 76.6977C112.985 76.5789 112.703 76.584 112.456 76.6789C112.416 76.6941 112.372 76.6883 112.334 76.668L112.327 76.6709C112.255 76.6412 112.222 76.5579 112.257 76.4869L112.794 75.2245L111.416 75.7535C111.344 75.7847 111.265 75.7499 111.238 75.6796C111.21 75.6064 111.245 75.5275 111.315 75.5006L112.997 74.855C113.069 74.8238 113.147 74.8586 113.174 74.9289C113.182 74.9492 113.183 74.9717 113.179 74.9919C113.179 75.0115 113.174 75.0282 113.168 75.0419L113.169 75.034Z"
        fill="#F8F8F8"
      />
      <path
        d="M117.203 76.4954L115.254 77.244L115.248 77.2498L115.239 77.2534C115.212 77.2635 115.181 77.2722 115.152 77.2563C115.079 77.2382 115.041 77.157 115.069 77.0889L116.147 73.6961L116.151 73.6867C116.176 73.6121 116.244 73.5787 116.319 73.6041C116.345 73.6128 116.364 73.6324 116.382 73.6483C116.385 73.6585 116.392 73.6635 116.396 73.6657L116.403 73.6824L117.355 76.1461L117.596 76.0541C117.669 76.0258 117.748 76.0606 117.774 76.1273C117.799 76.194 117.764 76.2729 117.694 76.2998L117.454 76.3918L117.691 77.0092C117.716 77.0758 117.682 77.1541 117.611 77.1809C117.545 77.207 117.466 77.1722 117.44 77.1048L117.203 76.4874L117.203 76.4954ZM117.108 76.249L116.293 74.1454L115.408 76.9085L117.111 76.2556L117.108 76.249Z"
        fill="#F8F8F8"
      />
      <path
        d="M118.777 76.3272C118.704 76.2975 118.672 76.2142 118.708 76.1468C118.738 76.0779 118.822 76.0453 118.891 76.0765C119.152 76.1866 119.431 76.1866 119.678 76.0924C119.925 75.9975 120.129 75.812 120.247 75.5482C120.364 75.2852 120.361 75.0069 120.266 74.7598C120.169 74.5098 119.982 74.2989 119.723 74.1837C119.464 74.0685 119.182 74.0729 118.936 74.1678C118.685 74.2642 118.478 74.4511 118.361 74.7142C118.329 74.7837 118.248 74.8185 118.18 74.783C118.16 74.7794 118.143 74.7671 118.135 74.7547L118.132 74.7482C118.132 74.7482 118.122 74.741 118.119 74.7337C118.108 74.7265 118.103 74.7098 118.098 74.6968C118.095 74.6895 118.094 74.6787 118.09 74.6685L117.703 73.1518C117.688 73.1113 117.695 73.0707 117.718 73.0388C117.73 73.0113 117.756 72.9895 117.79 72.9772L119.464 72.3339C119.537 72.3024 119.615 72.3373 119.642 72.4074C119.671 72.4844 119.635 72.5591 119.565 72.5859L117.997 73.1881L118.282 74.3113C118.425 74.1345 118.612 73.9931 118.829 73.9105C119.142 73.7895 119.492 73.7823 119.826 73.9337C120.161 74.0772 120.392 74.3402 120.515 74.6605C120.632 74.9678 120.645 75.3301 120.492 75.6605C120.345 75.9852 120.076 76.2301 119.766 76.3497C119.452 76.47 119.093 76.4736 118.766 76.3279L118.777 76.3272Z"
        fill="#F8F8F8"
      />
      <path
        d="M121.25 72.5494C121.33 72.0172 121.617 71.5313 122.207 71.282C122.272 71.2497 122.35 71.2847 122.382 71.3489C122.41 71.4223 122.375 71.5007 122.31 71.5297C121.815 71.7465 121.596 72.1252 121.513 72.5863C121.47 72.8436 121.488 73.1276 121.536 73.4044C121.659 73.074 121.914 72.7921 122.267 72.6566C122.932 72.4014 123.666 72.7283 123.917 73.382C124.17 74.0399 123.846 74.7725 123.186 75.0298C122.542 75.2769 121.824 74.9711 121.556 74.3421C121.516 74.2697 121.487 74.1928 121.455 74.1095C121.275 73.6305 121.17 73.0696 121.254 72.5479L121.25 72.5494ZM121.799 74.2262C121.809 74.253 121.823 74.2704 121.834 74.2892C121.841 74.3059 121.844 74.316 121.841 74.3283C122.081 74.761 122.613 74.9624 123.083 74.782C123.607 74.5805 123.865 73.9957 123.668 73.482C123.471 72.9675 122.886 72.7102 122.362 72.911C121.848 73.1088 121.59 73.6936 121.787 74.2073L121.795 74.2276L121.799 74.2262Z"
        fill="#F8F8F8"
      />
      <path
        d="M102.429 90.1475L71.083 102.274L71.6789 103.814L103.025 91.6873L102.429 90.1475Z"
        fill="url(#paint11_linear_372_10548)"
      />
      <path
        d="M94.5992 97.1123L72.4072 105.698L73.0028 107.238L95.1948 98.6529L94.5992 97.1123Z"
        fill="url(#paint12_linear_372_10548)"
      />
      <path
        d="M103.062 60.2814L88.9706 65.7329C88.5453 65.8974 88.3337 66.3756 88.4982 66.8009C88.6627 67.2261 89.1409 67.4376 89.5663 67.273L103.658 61.8216C104.083 61.657 104.294 61.1789 104.129 60.7536C103.965 60.3283 103.487 60.1169 103.062 60.2814Z"
        fill="#3B3B3B"
      />
      <path
        d="M128.885 99.6279L55.4404 113.905L61.1558 143.308L134.601 129.032L128.885 99.6279Z"
        fill="url(#paint13_linear_372_10548)"
      />
      <path
        opacity="0.2"
        d="M128.885 99.6279L55.4404 113.905L61.1558 143.308L134.601 129.032L128.885 99.6279Z"
        fill="black"
      />
      <path
        d="M135.668 146.629L63.3088 150.29C59.7059 150.473 56.5176 147.977 55.8293 144.436L45.413 90.8492C45.1672 89.5847 46.4666 88.5796 47.6288 89.1354C48.9775 89.7796 50.4762 90.0528 51.97 89.9267L116.973 84.3666C120.663 84.0506 123.997 86.568 124.704 90.2035L135.671 146.625C135.671 146.626 135.67 146.628 135.668 146.629Z"
        fill="url(#paint14_linear_372_10548)"
      />
      <path
        d="M120.3 120.238C121.984 119.911 123.047 118.09 122.673 116.172C122.301 114.254 120.634 112.964 118.95 113.291C117.265 113.618 116.202 115.439 116.576 117.358C116.949 119.276 118.616 120.565 120.3 120.238Z"
        fill="#EBEBEB"
      />
      <path
        d="M121.042 116.49C121.215 117.381 120.721 118.228 119.939 118.379C119.156 118.531 118.381 117.932 118.207 117.041C118.034 116.15 118.528 115.304 119.311 115.152C120.094 114.999 120.869 115.599 121.042 116.49Z"
        fill="#DBDBDB"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_372_10548"
        x="-14.8691"
        y="-14.8691"
        width="229.739"
        height="229.739"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="27"
          result="effect1_foregroundBlur_372_10548"
        />
      </filter>
      <linearGradient
        id="paint0_linear_372_10548"
        x1="39.9158"
        y1="16.667"
        x2="167.118"
        y2="43.146"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#030234" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_372_10548"
        x1="58.841"
        y1="39.1309"
        x2="176.564"
        y2="61.8346"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" stopOpacity="0" />
        <stop offset="1" stopColor="#FF6250" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_372_10548"
        x1="163.543"
        y1="158.793"
        x2="174.216"
        y2="167.177"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#377DF7" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_372_10548"
        x1="42.3165"
        y1="170.671"
        x2="41.9599"
        y2="181.291"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#377DF7" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_372_10548"
        x1="167.483"
        y1="48.7378"
        x2="178.092"
        y2="48.1294"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#377DF7" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_372_10548"
        x1="127.211"
        y1="97.151"
        x2="153.371"
        y2="101.674"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#3B3B3B" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_372_10548"
        x1="109.998"
        y1="162.968"
        x2="81.7383"
        y2="107.472"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#3B3B3B" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_372_10548"
        x1="63.7799"
        y1="68.0428"
        x2="131.838"
        y2="62.1643"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#FE84AA" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_372_10548"
        x1="116.138"
        y1="84.4319"
        x2="123.281"
        y2="83.1616"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#FF6250" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_372_10548"
        x1="120.368"
        y1="82.7926"
        x2="127.511"
        y2="81.5224"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#3B3B3B" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_372_10548"
        x1="63.1226"
        y1="75.737"
        x2="75.8978"
        y2="74.4935"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#3B3B3B" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_372_10548"
        x1="76.1579"
        y1="100.311"
        x2="80.984"
        y2="107.091"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#FF6250" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_372_10548"
        x1="75.9999"
        y1="104.308"
        x2="81.2956"
        y2="110.412"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#FF6250" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_372_10548"
        x1="67.3314"
        y1="111.593"
        x2="132.718"
        y2="128.773"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#3B3B3B" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_372_10548"
        x1="116.155"
        y1="128.78"
        x2="2.88451"
        y2="74.418"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="0.666667" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_372_10548">
        <rect width="200" height="200" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const GrowIcon = () => (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_372_10597)">
      <path
        d="M100 183.334C146.024 183.334 183.334 146.024 183.334 100C183.334 53.9766 146.024 16.667 100 16.667C53.9766 16.667 16.667 53.9766 16.667 100C16.667 146.024 53.9766 183.334 100 183.334Z"
        fill="url(#paint0_linear_372_10597)"
      />
      <g filter="url(#filter0_f_372_10597)">
        <path
          d="M100 160.87C133.618 160.87 160.87 133.618 160.87 100C160.87 66.3831 133.618 39.1309 100 39.1309C66.3831 39.1309 39.1309 66.3831 39.1309 100C39.1309 133.618 66.3831 160.87 100 160.87Z"
          fill="url(#paint1_linear_372_10597)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.2146 37.3769C61.6088 37.3769 62.739 36.2467 62.739 34.8525C62.739 33.4584 61.6088 32.3281 60.2146 32.3281C58.8204 32.3281 57.6902 33.4584 57.6902 34.8525C57.6902 36.2467 58.8204 37.3769 60.2146 37.3769ZM60.2146 39.2702C62.6544 39.2702 64.6323 37.2924 64.6323 34.8525C64.6323 32.4127 62.6544 30.4348 60.2146 30.4348C57.7748 30.4348 55.7969 32.4127 55.7969 34.8525C55.7969 37.2924 57.7748 39.2702 60.2146 39.2702Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.0261 143.898C38.4203 143.898 39.5505 142.768 39.5505 141.373C39.5505 139.979 38.4203 138.85 37.0261 138.85C35.632 138.85 34.5017 139.979 34.5017 141.373C34.5017 142.768 35.632 143.898 37.0261 143.898ZM37.0261 145.792C39.4659 145.792 41.4438 143.813 41.4438 141.373C41.4438 138.934 39.4659 136.956 37.0261 136.956C34.5863 136.956 32.6084 138.934 32.6084 141.373C32.6084 143.813 34.5863 145.792 37.0261 145.792Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M163.837 72.8844C165.232 72.8844 166.362 71.7543 166.362 70.3601C166.362 68.9659 165.232 67.8357 163.837 67.8357C162.443 67.8357 161.313 68.9659 161.313 70.3601C161.313 71.7543 162.443 72.8844 163.837 72.8844ZM163.837 74.7779C166.277 74.7779 168.255 72.7996 168.255 70.3601C168.255 67.9203 166.277 65.9424 163.837 65.9424C161.397 65.9424 159.42 67.9203 159.42 70.3601C159.42 72.7996 161.397 74.7779 163.837 74.7779Z"
        fill="white"
      />
      <path
        d="M31.4432 37.8179C31.6289 37.0487 32.723 37.0487 32.9087 37.8179L33.5336 40.4067C33.6 40.6816 33.8146 40.8962 34.0895 40.9626L36.6783 41.5875C37.4475 41.7732 37.4475 42.8673 36.6783 43.0529L34.0895 43.6779C33.8146 43.7442 33.6 43.9588 33.5336 44.2337L32.9087 46.8226C32.723 47.5918 31.6289 47.5918 31.4432 46.8226L30.8183 44.2337C30.7519 43.9588 30.5373 43.7442 30.2624 43.6779L27.6736 43.0529C26.9044 42.8673 26.9044 41.7732 27.6736 41.5875L30.2624 40.9626C30.5373 40.8962 30.7519 40.6816 30.8183 40.4067L31.4432 37.8179Z"
        fill="white"
      />
      <path
        d="M166.155 37.385C166.358 36.5419 167.557 36.5419 167.761 37.385L168.447 40.2227C168.519 40.524 168.755 40.7593 169.055 40.8321L171.893 41.517C172.736 41.7205 172.736 42.9198 171.893 43.1234L169.055 43.8084C168.755 43.8811 168.519 44.1163 168.447 44.4176L167.761 47.2554C167.557 48.0985 166.358 48.0985 166.155 47.2554L165.47 44.4176C165.397 44.1163 165.162 43.8811 164.86 43.8084L162.023 43.1234C161.18 42.9198 161.18 41.7205 162.023 41.517L164.86 40.8321C165.162 40.7593 165.397 40.524 165.47 40.2227L166.155 37.385Z"
        fill="url(#paint2_linear_372_10597)"
      />
      <path
        d="M39.8779 160.316C40.8373 160.163 41.6033 161.105 41.2566 162.013L38.9167 168.14C38.5701 169.048 37.3708 169.24 36.758 168.485L32.6219 163.395C32.009 162.642 32.4424 161.507 33.4018 161.353L39.8779 160.316Z"
        fill="url(#paint3_linear_372_10597)"
      />
      <path
        d="M155.056 143.483C154.816 142.541 155.685 141.693 156.62 141.956L162.935 143.73C163.87 143.993 164.17 145.17 163.475 145.848L158.781 150.429C158.086 151.108 156.917 150.779 156.676 149.838L155.056 143.483Z"
        fill="url(#paint4_linear_372_10597)"
      />
      <path
        d="M132.252 111.496L75.9865 91.016C71.6734 89.4464 66.9044 91.6704 65.3347 95.9834L52.0523 132.476C50.4825 136.789 52.7063 141.558 57.0192 143.128L113.286 163.607C117.599 165.177 122.368 162.953 123.937 158.64L137.22 122.147C138.789 117.834 136.565 113.065 132.252 111.496Z"
        fill="url(#paint5_linear_372_10597)"
      />
      <path
        d="M129.969 122.799L146.59 98.8573C149.207 95.087 148.273 89.9087 144.503 87.2914L120.561 70.6702C116.791 68.0527 111.613 68.9872 108.995 72.7573L92.3743 96.6986C89.7569 100.469 90.691 105.647 94.4613 108.265L118.403 124.886C122.173 127.503 127.351 126.568 129.969 122.799Z"
        fill="url(#paint6_linear_372_10597)"
      />
      <path
        d="M103 96.3923L109 86L112.831 88.212L109.724 98.4931L109.999 98.6517L115.228 89.5956L117.212 90.7412L111.212 101.134L107.381 98.9215L110.488 88.6404L110.213 88.4818L104.984 97.5379L103 96.3923Z"
        fill="#FEFEFF"
      />
      <path
        d="M113.226 102.296L119.226 91.9038L125.942 95.7813L124.913 97.5629L120.212 94.8486L118.763 97.3576L123.098 99.8604L122.07 101.642L117.735 99.1391L115.24 103.459L113.226 102.296Z"
        fill="#FEFEFF"
      />
      <path
        d="M123.852 108.431L128.824 99.8205L125.71 98.0227L126.738 96.2412L134.981 101L133.952 102.782L130.838 100.984L125.867 109.595L123.852 108.431Z"
        fill="#FEFEFF"
      />
      <path
        d="M117.66 69.8048L112.793 47.2542C111.825 42.7678 107.402 39.9157 102.916 40.8841L73.4277 47.2489C68.9415 48.2172 66.0896 52.6393 67.058 57.1257L71.9253 79.6764C72.8937 84.1626 77.3154 87.0148 81.8024 86.0467L111.29 79.6814C115.777 78.7133 118.628 74.2916 117.66 69.8048Z"
        fill="url(#paint7_linear_372_10597)"
      />
      <path
        d="M117.276 67.4867L100.747 54.2148L94.3562 66.8136L87.6243 62.9326L78.317 75.8885L71.3359 77.3928L71.6683 78.9551C72.7902 84.1414 77.9011 87.4406 83.0873 86.3182L110.237 80.4595C115.424 79.3377 118.723 74.2269 117.6 69.0409L117.268 67.4867H117.276Z"
        fill="url(#paint8_linear_372_10597)"
      />
      <path
        opacity="0.9"
        d="M78.1506 61.4281C80.7354 61.3616 82.4057 58.7687 81.3999 56.3919C80.8347 55.0623 79.4803 54.1897 78.0339 54.2228C75.4499 54.2894 73.7789 56.8823 74.7847 59.2591C75.3499 60.5887 76.7042 61.4613 78.1506 61.4281Z"
        fill="white"
      />
      <path
        d="M123.067 157.304C121.917 162.139 116.809 164.89 112.14 163.19L55.9782 142.749C52.0134 141.306 49.7592 137.121 50.7357 133.016L58.711 99.4916C59.8611 94.6568 64.9686 91.9054 69.6383 93.6054L125.8 114.047C129.764 115.489 132.019 119.674 131.043 123.779L123.067 157.304Z"
        fill="url(#paint9_linear_372_10597)"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_372_10597"
        x="-14.8691"
        y="-14.8691"
        width="229.739"
        height="229.739"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="27"
          result="effect1_foregroundBlur_372_10597"
        />
      </filter>
      <linearGradient
        id="paint0_linear_372_10597"
        x1="39.9158"
        y1="16.667"
        x2="167.118"
        y2="43.146"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#030234" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_372_10597"
        x1="170.29"
        y1="110.145"
        x2="124.996"
        y2="188.22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" stopOpacity="0" />
        <stop offset="1" stopColor="#FF6250" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_372_10597"
        x1="169.339"
        y1="39.2271"
        x2="180.013"
        y2="47.6109"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#377DF7" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_372_10597"
        x1="40.8673"
        y1="163.424"
        x2="40.5107"
        y2="174.044"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#377DF7" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_372_10597"
        x1="158.061"
        y1="142.216"
        x2="168.67"
        y2="141.607"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#377DF7" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_372_10597"
        x1="115.273"
        y1="118.43"
        x2="146.313"
        y2="192.615"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#087BD1" />
        <stop offset="0.416667" stopColor="#A259FF" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_372_10597"
        x1="90.8896"
        y1="69.1855"
        x2="158.068"
        y2="85.9782"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#0CDFD2" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_372_10597"
        x1="66.8691"
        y1="40.6953"
        x2="125.88"
        y2="57.2083"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FE81AB" />
        <stop offset="1" stopColor="#FDAA94" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_372_10597"
        x1="92.3141"
        y1="98.5515"
        x2="82.0924"
        y2="60.7947"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_372_10597"
        x1="109.612"
        y1="146.96"
        x2="70.5239"
        y2="47.5085"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#36A3F5" />
        <stop offset="0.666667" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_372_10597">
        <rect width="200" height="200" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const CashIcon = () => (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_372_10626)">
      <path
        d="M100 183.334C146.024 183.334 183.334 146.024 183.334 100C183.334 53.9766 146.024 16.667 100 16.667C53.9766 16.667 16.667 53.9766 16.667 100C16.667 146.024 53.9766 183.334 100 183.334Z"
        fill="url(#paint0_linear_372_10626)"
      />
      <g filter="url(#filter0_f_372_10626)">
        <path
          d="M105.072 160.87C135.888 160.87 160.87 135.888 160.87 105.072C160.87 74.2566 135.888 49.2754 105.072 49.2754C74.2566 49.2754 49.2754 74.2566 49.2754 105.072C49.2754 135.888 74.2566 160.87 105.072 160.87Z"
          fill="url(#paint1_linear_372_10626)"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.9978 65.6374C46.392 65.6374 47.5222 64.5072 47.5222 63.113C47.5222 61.7189 46.392 60.5886 44.9978 60.5886C43.6036 60.5886 42.4734 61.7189 42.4734 63.113C42.4734 64.5072 43.6036 65.6374 44.9978 65.6374ZM44.9978 67.5307C47.4376 67.5307 49.4155 65.5528 49.4155 63.113C49.4155 60.6732 47.4376 58.6953 44.9978 58.6953C42.558 58.6953 40.5801 60.6732 40.5801 63.113C40.5801 65.5528 42.558 67.5307 44.9978 67.5307Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.0261 143.898C38.4203 143.898 39.5505 142.768 39.5505 141.373C39.5505 139.979 38.4203 138.85 37.0261 138.85C35.632 138.85 34.5017 139.979 34.5017 141.373C34.5017 142.768 35.632 143.898 37.0261 143.898ZM37.0261 145.792C39.4659 145.792 41.4438 143.813 41.4438 141.373C41.4438 138.934 39.4659 136.956 37.0261 136.956C34.5863 136.956 32.6084 138.934 32.6084 141.373C32.6084 143.813 34.5863 145.792 37.0261 145.792Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M154.417 37.3769C155.812 37.3769 156.942 36.2467 156.942 34.8525C156.942 33.4584 155.812 32.3281 154.417 32.3281C153.023 32.3281 151.893 33.4584 151.893 34.8525C151.893 36.2467 153.023 37.3769 154.417 37.3769ZM154.417 39.2702C156.857 39.2702 158.835 37.2924 158.835 34.8525C158.835 32.4127 156.857 30.4348 154.417 30.4348C151.978 30.4348 150 32.4127 150 34.8525C150 37.2924 151.978 39.2702 154.417 39.2702Z"
        fill="white"
      />
      <path
        d="M47.3846 30.571C47.5703 29.8018 48.6644 29.8018 48.8501 30.571L49.475 33.1599C49.5414 33.4347 49.7559 33.6494 50.0309 33.7158L52.6197 34.3407C53.3889 34.5263 53.3889 35.6205 52.6197 35.8061L50.0309 36.431C49.7559 36.4974 49.5414 36.712 49.475 36.9869L48.8501 39.5758C48.6644 40.345 47.5703 40.345 47.3846 39.5758L46.7597 36.9869C46.6933 36.712 46.4787 36.4974 46.2038 36.431L43.615 35.8061C42.8458 35.6205 42.8458 34.5263 43.615 34.3407L46.2038 33.7158C46.4787 33.6494 46.6933 33.4347 46.7597 33.1599L47.3846 30.571Z"
        fill="white"
      />
      <path
        d="M163.981 56.9507C164.184 56.1076 165.384 56.1076 165.587 56.9507L166.273 59.7884C166.345 60.0897 166.581 60.325 166.881 60.3977L169.719 61.0827C170.563 61.2862 170.563 62.4855 169.719 62.689L166.881 63.374C166.581 63.4468 166.345 63.682 166.273 63.9833L165.587 66.8211C165.384 67.6642 164.184 67.6642 163.981 66.8211L163.296 63.9833C163.224 63.682 162.988 63.4468 162.687 63.374L159.849 62.689C159.006 62.4855 159.006 61.2862 159.849 61.0827L162.687 60.3977C162.988 60.325 163.224 60.0897 163.296 59.7884L163.981 56.9507Z"
        fill="url(#paint2_linear_372_10626)"
      />
      <path
        d="M39.8779 160.317C40.8373 160.163 41.6033 161.106 41.2566 162.013L38.9167 168.14C38.5701 169.048 37.3708 169.24 36.758 168.486L32.6219 163.396C32.009 162.642 32.4424 161.508 33.4018 161.354L39.8779 160.317Z"
        fill="url(#paint3_linear_372_10626)"
      />
      <path
        d="M152.882 146.382C152.642 145.44 153.511 144.592 154.447 144.854L160.761 146.629C161.696 146.892 161.997 148.069 161.301 148.747L156.608 153.328C155.912 154.007 154.743 153.678 154.502 152.737L152.882 146.382Z"
        fill="url(#paint4_linear_372_10626)"
      />
      <g filter="url(#filter1_f_372_10626)">
        <path
          d="M144.221 164.106C144.221 168.577 123.012 172.201 96.8497 172.201C70.6874 172.201 49.4785 168.577 49.4785 164.106C49.4785 159.635 70.6874 156.011 96.8497 156.011C123.012 156.011 144.221 159.635 144.221 164.106Z"
          fill="url(#paint5_radial_372_10626)"
        />
      </g>
      <g filter="url(#filter2_i_372_10626)">
        <path
          d="M97.7721 47.8923L66.9181 53.3326C64.4394 53.7697 62.7843 56.1334 63.2214 58.6121L70.9975 102.713C71.4345 105.192 73.7983 106.847 76.277 106.409L107.131 100.969C109.61 100.532 111.265 98.1687 110.828 95.6897L103.052 51.589C102.614 49.1103 100.25 47.4552 97.7721 47.8923Z"
          fill="url(#paint6_linear_372_10626)"
        />
      </g>
      <path
        d="M98.2178 70.5619L74.2499 74.7881C73.4428 74.9304 72.9039 75.7 73.0462 76.5071L73.0471 76.5119C73.1894 77.319 73.9591 77.8579 74.7661 77.7156L98.7344 73.4893C99.5409 73.347 100.08 72.5774 99.938 71.7703L99.9373 71.7655C99.7946 70.9584 99.025 70.4195 98.2178 70.5619Z"
        fill="#1178C5"
      />
      <path
        d="M101.864 91.1579L78.1026 95.3478C77.3025 95.4891 76.7656 96.2369 76.9034 97.0188L76.9042 97.0239C77.0421 97.8058 77.8025 98.3253 78.6027 98.184L102.364 93.9942C103.165 93.8529 103.701 93.105 103.564 92.3232L103.563 92.3181C103.425 91.5362 102.664 91.0166 101.864 91.1579Z"
        fill="#1178C5"
      />
      <path
        d="M99.9645 80.3815L76.2022 84.5714C75.402 84.7127 74.8651 85.4605 75.003 86.2424L75.0038 86.2475C75.1417 87.0293 75.9021 87.5489 76.7022 87.4076L100.464 83.2177C101.264 83.0764 101.801 82.3283 101.664 81.5464L101.663 81.5418C101.525 80.7599 100.764 80.2404 99.9645 80.3815Z"
        fill="#1178C5"
      />
      <path
        d="M80.3247 57.9911L73.3206 59.2261C71.7691 59.4997 70.7331 60.9792 71.0067 62.5306L71.3495 64.4744C71.623 66.0259 73.1025 67.0618 74.654 66.7882L81.6581 65.5532C83.2095 65.2797 84.2457 63.8002 83.9718 62.2487L83.629 60.305C83.3558 58.7535 81.8761 57.7175 80.3247 57.9911Z"
        fill="#1178C5"
      />
      <g filter="url(#filter3_i_372_10626)">
        <path
          d="M134.542 60.053H93.7206C91.8184 60.053 90.2764 61.5951 90.2764 63.4973V82.6849C90.2764 84.587 91.8184 86.1291 93.7206 86.1291H134.542C136.444 86.1291 137.987 84.587 137.987 82.6849V63.4973C137.987 61.5951 136.444 60.053 134.542 60.053Z"
          fill="url(#paint7_linear_372_10626)"
        />
      </g>
      <path
        d="M100.351 77.0476C102.538 77.0476 104.311 75.2747 104.311 73.0877C104.311 70.9008 102.538 69.1279 100.351 69.1279C98.1641 69.1279 96.3916 70.9008 96.3916 73.0877C96.3916 75.2747 98.1641 77.0476 100.351 77.0476Z"
        fill="white"
      />
      <path
        d="M114.503 77.0476C116.69 77.0476 118.463 75.2747 118.463 73.0877C118.463 70.9008 116.69 69.1279 114.503 69.1279C112.316 69.1279 110.543 70.9008 110.543 73.0877C110.543 75.2747 112.316 77.0476 114.503 77.0476Z"
        fill="white"
      />
      <path
        d="M128.654 77.0476C130.84 77.0476 132.613 75.2747 132.613 73.0877C132.613 70.9008 130.84 69.1279 128.654 69.1279C126.467 69.1279 124.693 70.9008 124.693 73.0877C124.693 75.2747 126.467 77.0476 128.654 77.0476Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.9111 128.996C93.2531 127.054 95.1038 125.759 97.0452 126.101L117.436 129.696C120.222 130.188 122.74 131.481 124.525 133.351C126.309 135.219 127.518 137.875 127 140.815C126.481 143.756 124.436 145.838 122.122 146.985C119.805 148.132 116.996 148.488 114.209 147.997L65.7581 139.454C63.8172 139.112 62.5212 137.26 62.8634 135.32C63.2057 133.378 65.0565 132.083 66.9975 132.425L115.449 140.968C116.894 141.222 118.138 140.993 118.955 140.589C119.772 140.184 119.94 139.751 119.971 139.576C120.001 139.402 119.992 138.939 119.363 138.28C118.734 137.621 117.643 136.98 116.197 136.725L95.722 132.403C93.7814 132.061 92.5683 130.936 92.9111 128.996Z"
        fill="url(#paint8_linear_372_10626)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M132.297 92.6638C133.063 91.0167 134.842 90.0907 136.631 90.4059L152.616 93.2247C154.799 93.6095 156.257 95.6907 155.872 97.874C155.487 100.057 153.405 101.514 151.223 101.129L138.271 98.845L130.621 115.267C129.685 117.277 127.297 118.146 125.288 117.211C123.279 116.275 122.409 113.887 123.345 111.878L132.297 92.6638Z"
        fill="url(#paint9_linear_372_10626)"
      />
      <path
        d="M75.3186 153.671C80.0473 154.505 84.5565 151.347 85.3905 146.618C86.2239 141.889 83.0666 137.381 78.338 136.547C73.6094 135.713 69.1001 138.871 68.2663 143.599C67.4326 148.328 70.59 152.837 75.3186 153.671Z"
        fill="url(#paint10_linear_372_10626)"
      />
      <path
        d="M128.609 99.9194L69.6061 89.5158C65.1832 88.7361 61.2548 91.9115 61.5629 96.0122L62.2997 119.943C62.5233 122.906 64.9408 125.405 68.1351 125.968L119.567 138.508L133.957 108.788C137.273 102.769 133.042 100.701 128.609 99.9194Z"
        fill="url(#paint11_linear_372_10626)"
      />
      <path
        d="M75.8308 149.381C78.2064 149.8 80.4719 148.214 80.8908 145.838C81.3096 143.463 79.7234 141.197 77.3477 140.778C74.9721 140.359 72.7067 141.945 72.2878 144.321C71.8689 146.697 73.4552 148.962 75.8308 149.381Z"
        fill="url(#paint12_linear_372_10626)"
      />
      <mask
        id="mask0_372_10626"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="61"
        y="89"
        width="74"
        height="50"
      >
        <path
          d="M128.609 99.9194L69.6061 89.5158C65.1832 88.7361 61.2548 91.9115 61.5629 96.0122L62.2997 119.943C62.5233 122.906 64.9408 125.405 68.1351 125.968L119.566 138.508L133.958 108.788C135.651 105.03 133.042 100.701 128.609 99.9194Z"
          fill="url(#paint13_linear_372_10626)"
        />
      </mask>
      <g mask="url(#mask0_372_10626)">
        <path
          d="M100.06 115.699C100.316 114.344 101.622 113.45 102.978 113.7C104.333 113.951 105.224 115.252 104.969 116.607L101.591 134.471C101.335 135.825 100.029 136.72 98.6738 136.47C97.318 136.22 96.4267 134.918 96.6824 133.564L100.06 115.699Z"
          fill="url(#paint14_linear_372_10626)"
        />
        <path
          d="M144.138 104.081C145.27 104.277 146.032 105.355 145.84 106.487L145.701 107.308C145.509 108.44 144.436 109.199 143.304 109.003L60.8054 94.6744C59.6737 94.4773 58.9119 93.3997 59.1038 92.2678L59.2429 91.4476C59.4348 90.3149 60.508 89.5562 61.6397 89.7526L144.138 104.081Z"
          fill="#1178C5"
        />
        <path
          d="M113.945 118.208C114.201 116.854 115.507 115.959 116.862 116.21C118.218 116.461 119.109 117.762 118.853 119.116L115.476 136.981C115.22 138.335 113.914 139.23 112.558 138.979C111.203 138.729 110.311 137.428 110.567 136.074L113.945 118.208Z"
          fill="url(#paint15_linear_372_10626)"
        />
        <path
          d="M86.1791 113.191C86.4349 111.836 87.7415 110.941 89.0965 111.191C90.4523 111.442 91.3436 112.743 91.0871 114.098L87.7103 131.962C87.4545 133.317 86.148 134.212 84.7922 133.962C83.4371 133.711 82.5457 132.409 82.8016 131.055L86.1791 113.191Z"
          fill="url(#paint16_linear_372_10626)"
        />
        <path
          d="M72.1358 110.715C72.3919 109.361 73.6983 108.466 75.0537 108.716C76.4091 108.966 77.3005 110.268 77.0444 111.622L73.6673 129.487C73.4112 130.841 72.1049 131.736 70.7494 131.486C69.3939 131.235 68.5026 129.934 68.7587 128.579L72.1358 110.715Z"
          fill="url(#paint17_linear_372_10626)"
        />
        <path
          d="M59.9429 89.7673C60.2022 88.2963 61.6046 87.3144 63.0752 87.5738L135.176 100.287C136.647 100.546 137.629 101.949 137.369 103.419C137.11 104.89 135.708 105.872 134.237 105.613L62.1362 92.8992C60.6656 92.6405 59.6836 91.2376 59.9429 89.7673Z"
          fill="url(#paint18_linear_372_10626)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_372_10626"
        x="-4.72461"
        y="-4.72461"
        width="219.594"
        height="219.594"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="27"
          result="effect1_foregroundBlur_372_10626"
        />
      </filter>
      <filter
        id="filter1_f_372_10626"
        x="28.7911"
        y="135.323"
        width="136.118"
        height="57.5647"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="10.3437"
          result="effect1_foregroundBlur_372_10626"
        />
      </filter>
      <filter
        id="filter2_i_372_10626"
        x="63.1514"
        y="47.8223"
        width="50.1306"
        height="64.2212"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="2.38455" dy="5.56394" />
        <feGaussianBlur stdDeviation="5.96137" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_372_10626"
        />
      </filter>
      <filter
        id="filter3_i_372_10626"
        x="90.2764"
        y="60.053"
        width="53.3358"
        height="29.8267"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="5.62585" dy="3.75056" />
        <feGaussianBlur stdDeviation="6.09467" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_372_10626"
        />
      </filter>
      <linearGradient
        id="paint0_linear_372_10626"
        x1="39.9158"
        y1="16.667"
        x2="167.118"
        y2="43.146"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#0B1B26" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_372_10626"
        x1="128.986"
        y1="150.241"
        x2="91.7718"
        y2="145.999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" stopOpacity="0" />
        <stop offset="1" stopColor="#FF6250" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_372_10626"
        x1="167.165"
        y1="58.7928"
        x2="177.839"
        y2="67.1766"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#377DF7" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_372_10626"
        x1="40.8673"
        y1="163.424"
        x2="40.5107"
        y2="174.045"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#377DF7" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_372_10626"
        x1="155.887"
        y1="145.114"
        x2="166.496"
        y2="144.506"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#A259FF" />
        <stop offset="1" stopColor="#377DF7" />
      </linearGradient>
      <radialGradient
        id="paint5_radial_372_10626"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(96.8497 164.106) rotate(90) scale(8.09507 47.3714)"
      >
        <stop stopColor="#2B2B2B" />
        <stop offset="1" stopColor="#2B2B2B" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint6_linear_372_10626"
        x1="63.1514"
        y1="47.8223"
        x2="120.378"
        y2="59.4664"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#0CDFD2" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_372_10626"
        x1="90.2764"
        y1="60.053"
        x2="139.525"
        y2="82.5772"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FE81AB" />
        <stop offset="1" stopColor="#FDAA94" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_372_10626"
        x1="113.54"
        y1="142.541"
        x2="103.475"
        y2="95.3014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#15D2DA" />
        <stop offset="0.666667" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_372_10626"
        x1="122.969"
        y1="90.3447"
        x2="160.665"
        y2="101.747"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#0CDFD2" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_372_10626"
        x1="81.2747"
        y1="149.726"
        x2="61.4161"
        y2="129.436"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#19D3DB" />
        <stop offset="0.666667" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_372_10626"
        x1="116.177"
        y1="126.543"
        x2="76.2601"
        y2="46.962"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1178C5" />
        <stop offset="0.666667" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_372_10626"
        x1="71.6505"
        y1="146.425"
        x2="84.0447"
        y2="148.814"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="#BCF3FF" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_372_10626"
        x1="61.5459"
        y1="89.3975"
        x2="141.552"
        y2="119.098"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#0CDFD2" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_372_10626"
        x1="96.6387"
        y1="113.658"
        x2="107.004"
        y2="114.608"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#0CDFD2" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_372_10626"
        x1="110.523"
        y1="116.168"
        x2="120.888"
        y2="117.117"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#0CDFD2" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_372_10626"
        x1="82.7578"
        y1="111.149"
        x2="93.1221"
        y2="112.099"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#0CDFD2" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_372_10626"
        x1="68.7148"
        y1="108.674"
        x2="79.0793"
        y2="109.623"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35A3F5" />
        <stop offset="1" stopColor="#0CDFD2" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_372_10626"
        x1="121.521"
        y1="101.817"
        x2="122.709"
        y2="86.7709"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#29B5EB" />
        <stop offset="0.666667" stopColor="white" />
      </linearGradient>
      <clipPath id="clip0_372_10626">
        <rect width="200" height="200" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const LogoIcon = () => (
  <svg
    width="165"
    height="34"
    viewBox="0 0 165 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.0454 19.4953C31.2753 19.4953 31.5454 18.664 31.5454 17.0013C31.5454 15.3387 31.2753 14.5048 30.0454 14.5048H5.07968V8.59114C5.07968 6.55874 7.04127 4.98789 11.5414 4.98789H17.1193C18.3126 4.98789 18.58 4.15658 18.58 2.49395C18.58 0.831316 18.3099 0 17.1193 0H11.3867C3.8078 0 0 2.81913 0 8.59376V24.9054C0 30.6354 3.8078 33.4991 11.3867 33.4991H29.93C31.1599 33.4991 31.43 32.6206 31.43 31.0052C31.43 29.3898 31.1599 28.5112 29.93 28.5112H11.5414C7.04127 28.5112 5.07968 26.8932 5.07968 24.908V19.5031H30.0454V19.4953Z"
      fill="#FEFEFF"
    />
    <path
      d="M58.043 7.39014H54.272C53.1181 7.39014 52.848 8.17425 52.848 9.74772C52.848 11.3212 53.1181 12.0581 54.272 12.0581H57.8883C62.197 12.0581 64.0432 13.1674 64.0432 14.9218V14.969H47.5769C40.3442 14.969 36.6885 17.6019 36.6885 23.0094V25.4588C36.6885 30.8191 40.3442 33.4992 47.5769 33.4992H58.0404C65.2732 33.4992 68.9262 30.8191 68.9262 25.4588V15.4332C68.9262 10.0283 65.2705 7.39276 58.0404 7.39276L58.043 7.39014ZM64.0432 25.4562C64.0432 27.305 62.197 28.8286 57.8883 28.8286H47.7316C43.4229 28.8286 41.5767 27.305 41.5767 25.4562V22.8232C41.5767 20.9298 43.4229 19.4508 47.7316 19.4508H64.0432V25.4562Z"
      fill="#FEFEFF"
    />
    <path
      d="M87.829 7.39007H84.8289C78.4039 7.39007 74.8662 10.0702 74.8662 15.3833V31.5087C74.8662 33.2658 75.6739 33.6801 77.2893 33.6801C78.9048 33.6801 79.7518 33.2631 79.7518 31.5087V15.3833C79.7518 13.2565 81.0211 12.0554 84.8289 12.0554H87.829C88.9829 12.0554 89.2136 11.2687 89.2136 9.74503C89.2136 8.22139 88.9829 7.38745 87.829 7.38745V7.39007Z"
      fill="#FEFEFF"
    />
    <path
      d="M113.589 7.39014H105.202C97.9695 7.39014 94.3164 10.0231 94.3164 15.4306V31.5088C94.3164 33.2658 95.1241 33.6802 96.7395 33.6802C98.355 33.6802 99.2021 33.2632 99.2021 31.5088V15.4306C99.2021 13.5372 101.048 12.0581 105.357 12.0581H113.437C117.745 12.0581 119.592 13.5372 119.592 15.4306V31.5088C119.592 33.2658 120.399 33.6802 122.015 33.6802C123.63 33.6802 124.477 33.2632 124.477 31.5088V15.4306C124.477 10.0257 120.821 7.39014 113.589 7.39014Z"
      fill="#FEFEFF"
    />
    <path
      d="M163.731 29.5235L151.19 16.9095L163.616 4.15658C164.578 3.13907 164.845 2.72472 164.845 1.89341C164.845 0.183572 163.576 0 162.383 0C161.19 0 160.458 0.183572 159.805 0.831316L147.647 13.3535L135.259 0.831316C134.643 0.183572 134.029 0 132.836 0C131.373 0 130.334 0.27798 130.334 1.89341C130.334 2.72472 130.604 3.14169 131.603 4.15658L143.837 16.5398L131.181 29.5235C130.219 30.541 129.951 30.9554 129.951 31.7867C129.951 33.4965 131.22 33.6801 132.49 33.6801C133.604 33.6801 134.299 33.5411 134.992 32.8488L147.38 20.0958L160.075 32.8488C160.768 33.5411 161.345 33.6801 162.462 33.6801C163.922 33.6801 165 33.4493 165 31.7867C165 30.9554 164.73 30.5384 163.731 29.5235Z"
      fill="#FEFEFF"
    />
  </svg>
)

export const InstagramIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="-100.7682 -167.947 873.3244 1007.682"
  >
    <g fill="#fff">
      <path d="M335.895 0c-91.224 0-102.663.387-138.49 2.021-35.752 1.631-60.169 7.31-81.535 15.612-22.088 8.584-40.82 20.07-59.493 38.743-18.674 18.673-30.16 37.407-38.743 59.495C9.33 137.236 3.653 161.653 2.02 197.405.386 233.232 0 244.671 0 335.895c0 91.222.386 102.661 2.02 138.488 1.633 35.752 7.31 60.169 15.614 81.534 8.584 22.088 20.07 40.82 38.743 59.495 18.674 18.673 37.405 30.159 59.493 38.743 21.366 8.302 45.783 13.98 81.535 15.612 35.827 1.634 47.266 2.021 138.49 2.021 91.222 0 102.661-.387 138.488-2.021 35.752-1.631 60.169-7.31 81.534-15.612 22.088-8.584 40.82-20.07 59.495-38.743 18.673-18.675 30.159-37.407 38.743-59.495 8.302-21.365 13.981-45.782 15.612-81.534 1.634-35.827 2.021-47.266 2.021-138.488 0-91.224-.387-102.663-2.021-138.49-1.631-35.752-7.31-60.169-15.612-81.534-8.584-22.088-20.07-40.822-38.743-59.495-18.675-18.673-37.407-30.159-59.495-38.743-21.365-8.302-45.782-13.981-81.534-15.612C438.556.387 427.117 0 335.895 0zm0 60.521c89.686 0 100.31.343 135.729 1.959 32.75 1.493 50.535 6.965 62.37 11.565 15.68 6.094 26.869 13.372 38.622 25.126 11.755 11.754 19.033 22.944 25.127 38.622 4.6 11.836 10.072 29.622 11.565 62.371 1.616 35.419 1.959 46.043 1.959 135.73 0 89.687-.343 100.311-1.959 135.73-1.493 32.75-6.965 50.535-11.565 62.37-6.094 15.68-13.372 26.869-25.127 38.622-11.753 11.755-22.943 19.033-38.621 25.127-11.836 4.6-29.622 10.072-62.371 11.565-35.413 1.616-46.036 1.959-135.73 1.959-89.694 0-100.315-.343-135.73-1.96-32.75-1.492-50.535-6.964-62.37-11.564-15.68-6.094-26.869-13.372-38.622-25.127-11.754-11.753-19.033-22.943-25.127-38.621-4.6-11.836-10.071-29.622-11.565-62.371-1.616-35.419-1.959-46.043-1.959-135.73 0-89.687.343-100.311 1.959-135.73 1.494-32.75 6.965-50.535 11.565-62.37 6.094-15.68 13.373-26.869 25.126-38.622 11.754-11.755 22.944-19.033 38.622-25.127 11.836-4.6 29.622-10.072 62.371-11.565 35.419-1.616 46.043-1.959 135.73-1.959" />
      <path d="M335.895 447.859c-61.838 0-111.966-50.128-111.966-111.964 0-61.838 50.128-111.966 111.966-111.966 61.836 0 111.964 50.128 111.964 111.966 0 61.836-50.128 111.964-111.964 111.964zm0-284.451c-95.263 0-172.487 77.224-172.487 172.487 0 95.261 77.224 172.485 172.487 172.485 95.261 0 172.485-77.224 172.485-172.485 0-95.263-77.224-172.487-172.485-172.487m219.608-6.815c0 22.262-18.047 40.307-40.308 40.307-22.26 0-40.307-18.045-40.307-40.307 0-22.261 18.047-40.308 40.307-40.308 22.261 0 40.308 18.047 40.308 40.308" />
    </g>
  </svg>
)

export const TwitterIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.7887 28C8.55374 28 5.53817 27.0591 3 25.4356C5.15499 25.5751 8.95807 25.2411 11.3236 22.9848C7.76508 22.8215 6.16026 20.0923 5.95094 18.926C6.25329 19.0426 7.6953 19.1826 8.50934 18.856C4.4159 17.8296 3.78793 14.2373 3.92748 13.141C4.695 13.6775 5.99745 13.8641 6.50913 13.8174C2.69479 11.0882 4.06703 6.98276 4.74151 6.09635C7.47882 9.88867 11.5812 12.0186 16.6564 12.137C16.5607 11.7174 16.5102 11.2804 16.5102 10.8316C16.5102 7.61092 19.1134 5 22.3247 5C24.0025 5 25.5144 5.71275 26.5757 6.85284C27.6969 6.59011 29.3843 5.97507 30.2092 5.4432C29.7934 6.93611 28.4989 8.18149 27.7159 8.64308C27.7095 8.62731 27.7224 8.65878 27.7159 8.64308C28.4037 8.53904 30.2648 8.18137 31 7.68256C30.6364 8.52125 29.264 9.91573 28.1377 10.6964C28.3473 19.9381 21.2765 28 11.7887 28Z"
      fill="#FEFEFF"
    />
  </svg>
)

export const FacebookIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="14" fill="#FEFEFF" />
    <path
      d="M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z"
      fill="#281D52"
    />
  </svg>
)

export const CopyIcon = () => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_502_2773)">
      <path
        d="M11.5263 2.49998H5.15789C4.52105 2.49998 4 3.0318 4 3.6818V11.3636C4 11.6886 4.26053 11.9545 4.57895 11.9545C4.89737 11.9545 5.15789 11.6886 5.15789 11.3636V4.27271C5.15789 3.94771 5.41842 3.6818 5.73684 3.6818H11.5263C11.8447 3.6818 12.1053 3.41589 12.1053 3.09089C12.1053 2.76589 11.8447 2.49998 11.5263 2.49998ZM13.8421 4.86362H7.47368C6.83684 4.86362 6.31579 5.39543 6.31579 6.04543V14.3182C6.31579 14.9682 6.83684 15.5 7.47368 15.5H13.8421C14.4789 15.5 15 14.9682 15 14.3182V6.04543C15 5.39543 14.4789 4.86362 13.8421 4.86362ZM13.2632 14.3182H8.05263C7.73421 14.3182 7.47368 14.0523 7.47368 13.7273V6.63634C7.47368 6.31134 7.73421 6.04543 8.05263 6.04543H13.2632C13.5816 6.04543 13.8421 6.31134 13.8421 6.63634V13.7273C13.8421 14.0523 13.5816 14.3182 13.2632 14.3182Z"
        fill="url(#paint0_linear_502_2773)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_502_2773"
        x1="4"
        y1="2.49998"
        x2="17.1419"
        y2="5.27967"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C12890" />
        <stop offset="1" stopColor="#FDAA94" />
      </linearGradient>
      <clipPath id="clip0_502_2773">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const FromIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="13.2266"
      cy="13.2382"
      r="12"
      transform="rotate(-180 13.2266 13.2382)"
      fill="#27C19F"
      fillOpacity="0.15"
    />
    <path
      d="M16.1443 9.79103L9.78034 16.155M9.78034 16.155L9.78034 11.382M9.78034 16.155L14.5533 16.155"
      stroke="#0C9D7D"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const ToIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="13.2285" cy="13.0475" r="12" fill="#E34446" fillOpacity="0.3" />
    <path
      d="M10.3108 16.4947L16.6747 10.1307M16.6747 10.1307L16.6747 14.9037M16.6747 10.1307L11.9018 10.1307"
      stroke="#E34446"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const MarketSellIcon = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.8186 6.63593C20.0836 6.12803 21.4984 6.12803 22.7635 6.63593L33.2615 10.851C34.1861 11.2222 34.791 12.1116 34.791 13.0997V26.4838C34.791 27.4718 34.1861 28.3612 33.2615 28.7325L22.7635 32.9475C21.4984 33.4554 20.0836 33.4554 18.8186 32.9475L8.32054 28.7325C7.39597 28.3612 6.79102 27.4718 6.79102 26.4838V13.0997C6.79102 12.1116 7.39597 11.2222 8.32054 10.851L18.8186 6.63593ZM21.9744 8.56339C21.2155 8.25866 20.3665 8.25866 19.6076 8.56339L16.9284 9.63911L27.4659 13.6977L31.2028 12.2687L21.9744 8.56339ZM24.5586 14.8095L14.0916 10.7781L10.4174 12.2533L20.7928 16.2495L24.5586 14.8095ZM8.89102 26.4838C8.89102 26.6249 8.97744 26.7519 9.10951 26.805L19.6076 31.02C19.6518 31.0379 19.6966 31.0547 19.7414 31.0704V18.0761L8.89102 13.897V26.4838ZM21.9744 31.02L32.4725 26.805C32.6046 26.7519 32.691 26.6249 32.691 26.4838V13.9291L21.8414 18.0779V31.0701C21.8861 31.0544 21.9305 31.0378 21.9744 31.02Z"
      fill="url(#paint0_linear_397_2071)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_397_2071"
        x1="6.79102"
        y1="6.255"
        x2="39.5501"
        y2="14.7241"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C12890" />
        <stop offset="1" stopColor="#FDAA94" />
      </linearGradient>
    </defs>
  </svg>
)

export const PlatformSell = () => (
  <svg
    width="30"
    height="29"
    viewBox="0 0 30 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.791016 14.7913H15.1007V28.6273H4.67973C2.53386 28.6273 0.791016 26.9429 0.791016 24.8673V14.7913Z"
      fill="#4F0D95"
    />
    <path
      d="M15.0996 0.955994V28.6274H29.4092V5.8821C29.4092 3.16174 27.128 0.955994 24.3145 0.955994H15.0996Z"
      fill="#F57598"
    />
    <path
      d="M22.2569 7.8736H7.94727V28.6274H22.2569V7.8736Z"
      fill="url(#paint0_linear_397_2083)"
    />
    <path d="M22.254 7.8736H15.0996V28.6274H22.254V7.8736Z" fill="#C12991" />
    <defs>
      <linearGradient
        id="paint0_linear_397_2083"
        x1="15.1025"
        y1="28.6274"
        x2="15.1025"
        y2="7.8736"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.21" stopColor="#A91C8B" stopOpacity="0.1" />
        <stop offset="0.25" stopColor="#A91C8B" stopOpacity="0.29" />
        <stop offset="0.3" stopColor="#A91C8B" stopOpacity="0.48" />
        <stop offset="0.35" stopColor="#A91C8B" stopOpacity="0.64" />
        <stop offset="0.41" stopColor="#A91C8B" stopOpacity="0.78" />
        <stop offset="0.48" stopColor="#A91C8B" stopOpacity="0.88" />
        <stop offset="0.57" stopColor="#A91C8B" stopOpacity="0.95" />
        <stop offset="0.69" stopColor="#A91C8B" stopOpacity="0.99" />
        <stop offset="1" stopColor="#A91C8B" />
      </linearGradient>
    </defs>
  </svg>
)

export const SecurityIcon = () => (
  <svg
    width="78"
    height="103"
    viewBox="0 0 80 103"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.0475 11.0963C9.62425 16.8071 0.8983 21.6593 0.678654 21.8789C0.279297 22.2583 0.279297 22.5379 0.279297 37.993C0.279297 54.9457 0.299265 55.4049 1.37753 60.7963C4.59235 76.8504 15.0355 90.8878 29.5322 98.5954C32.1879 100.013 38.8372 102.928 39.3963 102.928C40.0552 102.908 48.7213 99.0946 51.1773 97.7168C56.2492 94.8814 60.0231 91.986 64.0766 87.8327C72.483 79.2266 77.5748 68.8233 79.3719 56.603C79.6715 54.6262 79.7314 52.0503 79.7913 38.3923L79.8711 22.4979L79.312 21.8989C78.6132 21.1601 40.195 0.693039 39.4961 0.693039C39.2366 0.693039 30.4906 5.36552 20.0475 11.0963ZM57.8865 14.5507L75.9574 24.1952V38.9514C75.9375 53.2484 75.9375 53.7875 75.4982 56.583C73.761 67.6253 69.1284 77.09 61.7004 84.7976C56.2492 90.4485 51.1973 93.843 42.8907 97.4173L39.3763 98.9348L36.501 97.6569C31.3692 95.4005 28.2942 93.6833 24.8997 91.1474C14.4165 83.34 7.14824 71.6388 4.89187 58.9991C4.13309 54.6861 4.07319 53.3882 4.07319 38.6719V24.2152L21.6449 14.5707C31.3093 9.25925 39.3564 4.90626 39.5161 4.90626C39.6759 4.90626 47.9425 9.23928 57.8865 14.5507Z"
      fill="#FEFEFF"
    />
    <path
      d="M54.8511 42.2859C53.7129 43.2045 48.6411 47.3378 43.5493 51.4712L34.3042 58.999L30.091 54.067C25.0391 48.1166 24.9593 48.0167 24.0208 48.0167C23.0623 48.0167 22.5631 48.3162 22.2237 49.1349C21.984 49.714 21.984 49.9137 22.2237 50.4528C22.5831 51.3314 32.6069 63.0126 33.2858 63.372C33.6453 63.5717 33.9847 63.5916 34.4639 63.4718C35.1429 63.2921 58.9445 44.0431 59.3039 43.4041C59.923 42.226 58.9445 40.6286 57.6067 40.6286C57.0076 40.6286 56.5484 40.9082 54.8511 42.2859Z"
      fill="#FEFEFF"
    />
  </svg>
)

export const GrowthIcon = () => (
  <svg
    width="78"
    height="110"
    viewBox="0 0 81 110"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.1337 0.370682C29.5398 1.46934 23.2896 4.35027 17.9916 9.62384C9.81273 17.7295 6.78531 30.3763 10.1789 42.0954C12.0833 48.6141 16.9174 55.2304 22.4351 58.8927C26.61 61.6759 32.201 63.6779 37.4746 64.3127L38.8662 64.4836V70.807V77.1304H25.2184C17.6987 77.1304 11.3753 77.2037 11.1555 77.2769C10.2522 77.6431 10.0569 78.6441 10.0569 83.112V87.3846H6.24818C2.43949 87.3846 1.73147 87.5066 1.09669 88.3367C0.876956 88.6297 0.803712 91.2177 0.779297 98.5665V108.406L1.38966 108.992L1.97562 109.602H12.1321H22.313L23.0211 108.869L23.7535 108.161L23.6803 98.3956L23.607 88.6297L23.0455 88.0682C22.5328 87.5311 22.2886 87.5066 18.2358 87.4334L13.9632 87.3602V84.1863V81.0368H40.5752H67.1872V84.1863V87.3602L62.9146 87.4334C58.8618 87.5066 58.6177 87.5311 58.1049 88.0682L57.5434 88.6297L57.4702 98.3956L57.3969 108.161L58.1294 108.869L58.8374 109.602H69.0183H79.1748L79.7608 108.992L80.3711 108.406V98.5665C80.3467 91.2177 80.2735 88.6297 80.0537 88.3367C79.419 87.5066 78.7109 87.3846 74.9022 87.3846H71.0936V83.112C71.0936 78.6441 70.8982 77.6431 69.9949 77.2769C69.7752 77.2037 63.5494 77.1304 56.1762 77.1304H42.7725V70.8314V64.5324L45.4826 64.1174C48.51 63.6291 53.0755 62.213 55.4682 61.0167C64.0865 56.7197 70.0193 48.9315 72.119 39.2388C72.8758 35.6499 72.8758 29.2777 72.119 25.6887C69.3113 12.6268 60.0093 3.47134 46.9963 0.956635C44.4327 0.468338 39.8428 0.150948 38.1337 0.370682ZM46.0929 4.74091C57.5922 6.93822 65.82 14.9707 68.3103 26.3967C68.8962 29.1312 69.0183 34.0629 68.5544 36.895C66.3571 50.2743 56.7621 59.1124 42.919 60.504C37.1572 61.09 31.0047 59.6007 25.7311 56.3291C24.4371 55.5234 22.6793 54.1074 21.1655 52.5937C17.5766 49.078 15.4525 45.7331 13.9632 41.2408C11.1555 32.9154 12.5716 23.4181 17.7231 16.0937C19.2368 13.9452 22.4351 10.7713 24.5836 9.25762C28.0017 6.91381 32.7381 5.00947 36.7909 4.37469C38.7441 4.08171 43.6515 4.25261 46.0929 4.74091ZM19.8227 98.4933V105.696H12.2542H4.68564V98.4933V91.2909H12.2542H19.8227V98.4933ZM76.4648 98.4933V105.696H68.8962H61.3277V98.4933V91.2909H68.8962H76.4648V98.4933Z"
      fill="#FEFEFF"
    />
    <path
      d="M39.477 13.0418C39.0131 13.4813 38.8666 13.8963 38.8666 14.702V15.8007L37.7923 15.9472C34.9847 16.3866 32.1281 18.6816 30.7365 21.6602C30.0773 23.0274 29.9552 23.589 29.9552 25.1271C29.9552 26.6652 30.0773 27.2023 30.6877 28.4231C31.9572 31.0354 34.6917 33.1595 37.7435 33.9408L38.8666 34.2093V39.8003V45.3913H34.9602C31.1271 45.3913 31.0295 45.4157 30.4435 46.0016C29.6623 46.7585 29.6623 47.613 30.4191 48.4919L31.0051 49.1755L34.9358 49.2488L38.8666 49.322V50.2254C38.891 51.2752 39.2572 51.8611 40.1606 52.203C41.5034 52.7157 42.7729 51.617 42.7729 49.9812C42.7729 49.1267 42.8218 49.0535 43.8228 48.8093C46.899 48.028 49.487 46.0505 50.7565 43.5113C51.3669 42.2662 51.4401 41.8267 51.4401 39.7759C51.4401 36.9438 50.9763 35.7963 49.0963 33.7943C47.7779 32.3782 46.0445 31.4017 44.0669 30.8889L42.895 30.596L42.8218 25.0538L42.7729 19.5117H46.5572C50.2682 19.5117 50.3659 19.4873 50.9519 18.9013C51.7575 18.1201 51.7575 16.997 50.9519 16.2157C50.3903 15.6298 50.2682 15.6054 46.606 15.6054H42.8462L42.6997 14.4579C42.48 12.5047 40.7465 11.7478 39.477 13.0418ZM38.8666 24.9806V30.2297L38.183 30.0344C36.3031 29.4973 35.0335 28.3498 34.2278 26.5187C33.5686 25.0294 33.7395 23.8575 34.7893 22.2706C35.5462 21.1719 37.6459 19.7559 38.5248 19.7559C38.8178 19.7559 38.8666 20.6836 38.8666 24.9806ZM44.897 35.3812C46.9967 36.602 48.0953 38.9702 47.5094 40.9966C46.9478 42.8765 45.4341 44.3414 43.4566 44.9274L42.7729 45.1227V39.8735C42.7729 33.8919 42.6753 34.1117 44.897 35.3812Z"
      fill="#FEFEFF"
    />
    <path
      d="M30.0528 88.0926L29.3447 88.8006V98.3712C29.3447 108.137 29.3936 108.577 30.2969 109.285C30.5899 109.504 33.2511 109.578 40.8929 109.602H51.0982L51.6842 108.992L52.2945 108.406V98.6153V88.8006L51.5865 88.0926L50.8785 87.3846H40.8196H30.7608L30.0528 88.0926ZM48.3882 98.4933V105.696H40.8196H33.2511V98.4933V91.2909H40.8196H48.3882V98.4933Z"
      fill="#FEFEFF"
    />
  </svg>
)

export const FooterLogo = () => (
  <svg
    width="142"
    height="40"
    viewBox="0 0 142 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.00146421 19.9971H19.9988V39.9944H7.48712C3.35558 39.9944 0 36.6403 0 32.5072V19.9956L0.00146421 19.9971Z"
      fill="#4F0D95"
    />
    <path
      d="M19.999 0V39.996H39.9963V7.11989C39.9963 3.18825 36.808 0 32.8764 0H19.999Z"
      fill="#F57598"
    />
    <path
      d="M29.9973 9.99854H10V39.9959H29.9973V9.99854Z"
      fill="url(#paint0_linear_667_4353)"
    />
    <path d="M29.9977 9.99854H19.999V39.9959H29.9977V9.99854Z" fill="#C12991" />
    <path
      d="M65.1369 17.9314C65.8314 17.9314 65.9839 17.462 65.9839 16.5231C65.9839 15.5843 65.8314 15.1134 65.1369 15.1134H51.0393V11.7741C51.0393 10.6264 52.147 9.73941 54.6881 9.73941H57.8378C58.5116 9.73941 58.6627 9.26999 58.6627 8.33113C58.6627 7.39228 58.5101 6.92285 57.8378 6.92285H54.6007C50.3211 6.92285 48.1709 8.51476 48.1709 11.7756V20.9864C48.1709 24.222 50.3211 25.8391 54.6007 25.8391H65.0717C65.7663 25.8391 65.9188 25.343 65.9188 24.4308C65.9188 23.5186 65.7663 23.0226 65.0717 23.0226H54.6881C52.147 23.0226 51.0393 22.1089 51.0393 20.9879V17.9359H65.1369V17.9314Z"
      fill="#FEFEFF"
    />
    <path
      d="M80.9481 11.0962H78.8187C78.1671 11.0962 78.0146 11.539 78.0146 12.4275C78.0146 13.316 78.1671 13.7321 78.8187 13.7321H80.8608C83.2938 13.7321 84.3363 14.3585 84.3363 15.3492V15.3758H75.0381C70.9539 15.3758 68.8896 16.8626 68.8896 19.9161V21.2992C68.8896 24.326 70.9539 25.8394 75.0381 25.8394H80.9467C85.0308 25.8394 87.0936 24.326 87.0936 21.2992V15.6379C87.0936 12.5859 85.0293 11.0977 80.9467 11.0977L80.9481 11.0962ZM84.3363 21.2977C84.3363 22.3417 83.2938 23.2021 80.8608 23.2021H75.1255C72.6924 23.2021 71.6499 22.3417 71.6499 21.2977V19.8109C71.6499 18.7418 72.6924 17.9066 75.1255 17.9066H84.3363V21.2977Z"
      fill="#FEFEFF"
    />
    <path
      d="M97.769 11.0962H96.075C92.4469 11.0962 90.4492 12.6096 90.4492 15.6098V24.7155C90.4492 25.7077 90.9053 25.9416 91.8175 25.9416C92.7297 25.9416 93.208 25.7062 93.208 24.7155V15.6098C93.208 14.4088 93.9248 13.7306 96.075 13.7306H97.769C98.4206 13.7306 98.5509 13.2864 98.5509 12.426C98.5509 11.5656 98.4206 11.0947 97.769 11.0947V11.0962Z"
      fill="#FEFEFF"
    />
    <path
      d="M112.31 11.0962H107.575C103.491 11.0962 101.428 12.583 101.428 15.6365V24.7155C101.428 25.7077 101.884 25.9416 102.796 25.9416C103.708 25.9416 104.187 25.7062 104.187 24.7155V15.6365C104.187 14.5673 105.229 13.7321 107.662 13.7321H112.225C114.658 13.7321 115.7 14.5673 115.7 15.6365V24.7155C115.7 25.7077 116.156 25.9416 117.068 25.9416C117.981 25.9416 118.459 25.7062 118.459 24.7155V15.6365C118.459 12.5844 116.395 11.0962 112.31 11.0962Z"
      fill="#FEFEFF"
    />
    <path
      d="M140.626 23.5942L133.544 16.4713L140.56 9.26999C141.104 8.69542 141.255 8.46145 141.255 7.99202C141.255 7.02651 140.538 6.92285 139.864 6.92285C139.191 6.92285 138.777 7.02651 138.409 7.39228L131.544 14.4633L124.548 7.39228C124.2 7.02651 123.853 6.92285 123.18 6.92285C122.353 6.92285 121.767 7.07982 121.767 7.99202C121.767 8.46145 121.92 8.6969 122.484 9.26999L129.392 16.2625L122.245 23.5942C121.702 24.1687 121.551 24.4027 121.551 24.8721C121.551 25.8376 122.268 25.9413 122.984 25.9413C123.614 25.9413 124.006 25.8628 124.397 25.4719L131.392 18.2705L138.561 25.4719C138.952 25.8628 139.278 25.9413 139.909 25.9413C140.734 25.9413 141.342 25.811 141.342 24.8721C141.342 24.4027 141.19 24.1672 140.626 23.5942Z"
      fill="#FEFEFF"
    />
    <path
      d="M51.9752 34.1543L50.5299 36.7324L49.0949 34.1543H48.1709L50.0723 37.4995V39.9133H50.9149V37.4995L52.8622 34.1543H51.9752Z"
      fill="#FEFEFF"
    />
    <path
      d="M56.2758 36.1011C56.0892 35.9175 55.8701 35.7813 55.6168 35.6895C55.3636 35.5977 55.0882 35.5518 54.789 35.5518C54.4899 35.5518 54.213 35.6021 53.9568 35.7028C53.7006 35.8035 53.477 35.9501 53.2845 36.1411C53.092 36.3322 52.9409 36.5691 52.8314 36.849C52.7218 37.1289 52.667 37.4487 52.667 37.8086C52.667 38.1684 52.7203 38.4749 52.8269 38.7459C52.9336 39.0169 53.0802 39.245 53.2653 39.4316C53.4504 39.6181 53.671 39.7573 53.9242 39.8521C54.1774 39.9469 54.4529 39.9943 54.752 39.9943C55.0512 39.9943 55.3281 39.9439 55.5843 39.8432C55.8404 39.7425 56.064 39.5945 56.2566 39.399C56.4491 39.2035 56.6001 38.9651 56.7097 38.6808C56.8193 38.3979 56.8741 38.0766 56.8741 37.7167C56.8741 37.3569 56.8208 37.0504 56.7141 36.7794C56.6075 36.5084 56.4609 36.2818 56.2758 36.0982V36.1011ZM55.9278 38.5371C55.8582 38.7415 55.7649 38.9059 55.6494 39.0303C55.5339 39.1546 55.3992 39.2435 55.2466 39.2953C55.0941 39.3472 54.9386 39.3723 54.7802 39.3723C54.6217 39.3723 54.4662 39.3427 54.3137 39.2805C54.1612 39.2198 54.0264 39.125 53.9065 38.9977C53.788 38.8703 53.6917 38.703 53.6177 38.5001C53.5451 38.2958 53.5081 38.0499 53.5081 37.7641C53.5081 37.4532 53.5437 37.1955 53.6133 36.9911C53.6829 36.7868 53.7761 36.6239 53.8917 36.5025C54.0072 36.381 54.1419 36.2951 54.2944 36.2463C54.447 36.1974 54.6025 36.1737 54.7609 36.1737C54.9194 36.1737 55.0748 36.2033 55.2274 36.2611C55.3799 36.3188 55.5147 36.4121 55.6346 36.5395C55.7531 36.6668 55.8493 36.8312 55.9219 37.0326C55.9944 37.234 56.0315 37.4769 56.0315 37.7641C56.0315 38.0751 55.9959 38.3328 55.9263 38.5371H55.9278Z"
      fill="#FEFEFF"
    />
    <path
      d="M60.7328 38.7719C60.5551 38.954 60.37 39.0977 60.1745 39.2013C59.979 39.305 59.7599 39.3568 59.5155 39.3568C59.3941 39.3568 59.2801 39.3405 59.1764 39.3065C59.0728 39.2724 58.9824 39.2176 58.9069 39.1421C58.8299 39.0666 58.7692 38.9644 58.7248 38.8356C58.6789 38.7067 58.6566 38.5527 58.6566 38.3691V35.6177H57.8525V38.4698C57.8525 38.9822 57.9917 39.3642 58.2687 39.6174C58.5456 39.8707 58.9069 39.9965 59.3526 39.9965C59.6636 39.9965 59.9361 39.9373 60.1715 39.8188C60.4055 39.7004 60.6025 39.5523 60.7609 39.3746H60.7979L60.9075 39.9136H61.5384V35.6162H60.7343V38.7704L60.7328 38.7719Z"
      fill="#FEFEFF"
    />
    <path
      d="M64.8374 35.5518C64.5264 35.5518 64.2524 35.6376 64.014 35.8079C63.7756 35.9782 63.6053 36.2004 63.5017 36.4758L63.3639 35.6169H62.7598V39.9143H63.555V37.6931C63.555 37.462 63.5876 37.2562 63.6512 37.0755C63.7149 36.8964 63.8038 36.7453 63.9163 36.6224C64.0289 36.501 64.1606 36.4092 64.3087 36.3485C64.4568 36.2877 64.6212 36.2566 64.7974 36.2566C64.9188 36.2566 65.024 36.2685 65.1128 36.2937C65.2017 36.3174 65.2816 36.3485 65.3557 36.3855L65.5112 35.6821C65.4253 35.6451 65.332 35.6154 65.2283 35.5903C65.1247 35.5666 64.9929 35.5532 64.8344 35.5532L64.8374 35.5518Z"
      fill="#FEFEFF"
    />
    <path
      d="M71.5757 34.606C71.398 34.4564 71.1877 34.3439 70.9448 34.2669C70.7005 34.1913 70.4295 34.1528 70.1318 34.1528H68.3223V39.9133H69.1634V37.6832H70.0223C70.3332 37.6832 70.6161 37.6461 70.8723 37.5736C71.1285 37.501 71.3506 37.3914 71.5401 37.2448C71.7297 37.0982 71.8748 36.9146 71.9785 36.691C72.0821 36.4689 72.1339 36.2053 72.1339 35.9002C72.1339 35.6203 72.0851 35.3716 71.9873 35.1554C71.8896 34.9392 71.7519 34.7555 71.5757 34.6074V34.606ZM71.1373 36.4526C71.0574 36.5962 70.9508 36.7073 70.813 36.7858C70.6753 36.8657 70.5095 36.9205 70.3155 36.9501C70.12 36.9812 69.9097 36.996 69.6846 36.996H69.1634V34.8296H69.9408C70.1052 34.8296 70.2666 34.8473 70.4251 34.8844C70.5835 34.9214 70.7242 34.9821 70.8456 35.0665C70.967 35.1524 71.0663 35.2635 71.1433 35.3997C71.2188 35.5374 71.2573 35.7062 71.2573 35.9076C71.2573 36.1268 71.2173 36.3089 71.1388 36.4511L71.1373 36.4526Z"
      fill="#FEFEFF"
    />
    <path
      d="M75.8317 35.8909C75.688 35.7694 75.5177 35.6821 75.3193 35.6302C75.1209 35.5784 74.9032 35.5532 74.6663 35.5532C74.5078 35.5532 74.3612 35.5621 74.2279 35.5814C74.0932 35.5991 73.9629 35.6273 73.8355 35.6643C73.7067 35.7013 73.5793 35.7487 73.452 35.8064C73.3246 35.8642 73.1869 35.9294 73.0403 36.0034L73.3513 36.5883C73.6134 36.4417 73.8459 36.3425 74.0502 36.2907C74.2546 36.2389 74.4352 36.2137 74.5937 36.2137C74.8617 36.2137 75.075 36.27 75.2334 36.3825C75.3919 36.495 75.4718 36.7068 75.4718 37.0178V37.3835H74.6485C74.0635 37.3835 73.5926 37.5005 73.2358 37.736C72.8789 37.9714 72.7012 38.3135 72.7012 38.7652C72.7012 38.9547 72.7367 39.125 72.8063 39.2775C72.8759 39.4301 72.9751 39.5589 73.104 39.6655C73.2313 39.7721 73.3824 39.8551 73.5571 39.9128C73.7304 39.9706 73.9214 40.0002 74.1287 40.0002C74.4027 40.0002 74.6529 39.9572 74.878 39.8714C75.1031 39.7855 75.3104 39.6433 75.5 39.4419H75.5177L75.6184 39.9173H76.2863V37.12C76.2863 36.8208 76.2463 36.5735 76.1678 36.3751C76.0879 36.1767 75.9768 36.0167 75.8346 35.8953L75.8317 35.8909ZM75.4792 38.8066C75.3208 39.0139 75.1386 39.165 74.9313 39.2598C74.724 39.3545 74.5197 39.4019 74.3183 39.4019C74.2146 39.4019 74.1154 39.3916 74.0206 39.3693C73.9258 39.3486 73.8444 39.3131 73.7733 39.2642C73.7037 39.2153 73.6474 39.1472 73.6045 39.0584C73.5615 38.9695 73.5408 38.8614 73.5408 38.7341C73.5408 38.5208 73.6371 38.3402 73.8281 38.1906C74.0191 38.041 74.3449 37.9611 74.801 37.9477L75.4777 37.93V38.8081L75.4792 38.8066Z"
      fill="#FEFEFF"
    />
    <path
      d="M79.52 35.5518C79.209 35.5518 78.9351 35.6376 78.6967 35.8079C78.4582 35.9782 78.2879 36.2004 78.1843 36.4758L78.0466 35.6169H77.4424V39.9143H78.2376V37.6931C78.2376 37.462 78.2702 37.2562 78.3339 37.0755C78.3975 36.8964 78.4864 36.7453 78.5989 36.6224C78.7115 36.501 78.8433 36.4092 78.9913 36.3485C79.1394 36.2877 79.3038 36.2566 79.48 36.2566C79.6015 36.2566 79.7066 36.2685 79.7954 36.2937C79.8843 36.3174 79.9643 36.3485 80.0383 36.3855L80.1938 35.6821C80.1079 35.6451 80.0146 35.6154 79.9109 35.5903C79.8073 35.5666 79.6755 35.5532 79.517 35.5532L79.52 35.5518Z"
      fill="#FEFEFF"
    />
    <path
      d="M83.114 39.2138C82.9674 39.2405 82.8341 39.2553 82.7112 39.2553C82.5409 39.2553 82.4017 39.2183 82.2951 39.1457C82.1884 39.0731 82.1351 38.9295 82.1351 38.7163V36.221H83.3968V35.6183H82.1351V34.2471H81.3399V35.6183H80.7002V36.221H81.3399V38.8273C81.3399 39.1812 81.4376 39.4507 81.6331 39.6359C81.8286 39.821 82.1396 39.9143 82.5661 39.9143C82.7734 39.9143 82.9718 39.8965 83.1599 39.8595C83.3494 39.8224 83.5049 39.781 83.6263 39.7321L83.499 39.119C83.3894 39.1561 83.2606 39.1872 83.1154 39.2153L83.114 39.2138Z"
      fill="#FEFEFF"
    />
    <path
      d="M86.6979 35.5518C86.3929 35.5518 86.1234 35.608 85.8894 35.7206C85.6539 35.8331 85.4303 35.996 85.2171 36.2093L85.0986 35.6154H84.4678V39.9128H85.2719V36.7868C85.6436 36.4032 86.0434 36.2107 86.4699 36.2107C86.7498 36.2107 86.9585 36.2877 87.0963 36.4447C87.234 36.6002 87.3021 36.809 87.3021 37.0711V39.9143H88.1062V36.9526C88.1062 36.5143 87.9818 36.1707 87.7316 35.9234C87.4813 35.6761 87.1377 35.5532 86.6979 35.5532V35.5518Z"
      fill="#FEFEFF"
    />
    <path
      d="M92.5117 36.073C92.3532 35.9086 92.1622 35.7798 91.9401 35.6895C91.7179 35.5977 91.4692 35.5518 91.1952 35.5518C90.8724 35.5518 90.5806 35.6051 90.3215 35.7117C90.0623 35.8183 89.8417 35.9679 89.6581 36.1604C89.4745 36.3529 89.3338 36.5854 89.2331 36.8593C89.1324 37.1333 89.082 37.4383 89.082 37.773C89.082 38.1625 89.1413 38.4986 89.2597 38.7785C89.3782 39.0584 89.5411 39.2894 89.7484 39.4686C89.9557 39.6478 90.1941 39.781 90.4666 39.8669C90.7391 39.9528 91.0293 39.9958 91.3403 39.9958C91.6143 39.9958 91.8719 39.9706 92.1133 39.9232C92.3532 39.8743 92.562 39.8107 92.7397 39.7307L92.5753 39.1369C92.3621 39.2228 92.1651 39.2835 91.986 39.3205C91.8068 39.3575 91.601 39.3753 91.3685 39.3753C90.9242 39.3753 90.5718 39.2479 90.3126 38.9918C90.0535 38.7356 89.9246 38.3698 89.9246 37.8944V37.8574H93.0063V37.4369C93.0063 37.157 92.9633 36.9008 92.8789 36.6683C92.793 36.4373 92.6716 36.2389 92.5131 36.0745L92.5117 36.073ZM89.9424 37.2977C89.9913 36.9497 90.1201 36.6698 90.3304 36.4566C90.5407 36.2433 90.8131 36.1367 91.1493 36.1367C91.3329 36.1367 91.4884 36.1663 91.6157 36.2285C91.7446 36.2892 91.8497 36.3721 91.9312 36.4758C92.0141 36.5795 92.0748 36.6994 92.1148 36.8371C92.1548 36.9748 92.174 37.1214 92.174 37.2814L89.9439 37.2992L89.9424 37.2977Z"
      fill="#FEFEFF"
    />
    <path
      d="M96.0141 35.5518C95.7032 35.5518 95.4292 35.6376 95.1908 35.8079C94.9524 35.9782 94.7821 36.2004 94.6784 36.4758L94.5407 35.6169H93.9365V39.9143H94.7317V37.6931C94.7317 37.462 94.7643 37.2562 94.828 37.0755C94.8917 36.8964 94.9805 36.7453 95.0931 36.6224C95.2056 36.501 95.3374 36.4092 95.4855 36.3485C95.6336 36.2877 95.7979 36.2566 95.9741 36.2566C96.0956 36.2566 96.2007 36.2685 96.2896 36.2937C96.3784 36.3174 96.4584 36.3485 96.5324 36.3855L96.6879 35.6821C96.602 35.6451 96.5088 35.6154 96.4051 35.5903C96.3014 35.5666 96.1696 35.5532 96.0112 35.5532L96.0141 35.5518Z"
      fill="#FEFEFF"
    />
    <path
      d="M99.4971 39.9133H100.338V37.3988H102.679V36.7132H100.338V34.8488H102.881V34.1543H99.4971V39.9133Z"
      fill="#FEFEFF"
    />
    <path
      d="M107.026 36.1011C106.839 35.9175 106.62 35.7813 106.367 35.6895C106.114 35.5977 105.838 35.5518 105.539 35.5518C105.24 35.5518 104.963 35.6021 104.707 35.7028C104.451 35.8035 104.227 35.9501 104.035 36.1411C103.842 36.3322 103.691 36.5691 103.581 36.849C103.472 37.1289 103.417 37.4487 103.417 37.8086C103.417 38.1684 103.47 38.4749 103.577 38.7459C103.684 39.0169 103.83 39.245 104.015 39.4316C104.2 39.6181 104.421 39.7573 104.674 39.8521C104.927 39.9469 105.203 39.9943 105.502 39.9943C105.801 39.9943 106.078 39.9439 106.334 39.8432C106.59 39.7425 106.814 39.5945 107.007 39.399C107.199 39.2035 107.35 38.9651 107.46 38.6808C107.569 38.3979 107.624 38.0766 107.624 37.7167C107.624 37.3569 107.571 37.0504 107.464 36.7794C107.358 36.5084 107.211 36.2818 107.026 36.0982V36.1011ZM106.678 38.5371C106.608 38.7415 106.515 38.9059 106.399 39.0303C106.284 39.1546 106.149 39.2435 105.997 39.2953C105.844 39.3472 105.689 39.3723 105.53 39.3723C105.372 39.3723 105.216 39.3427 105.064 39.2805C104.911 39.2198 104.776 39.125 104.656 38.9977C104.538 38.8703 104.442 38.703 104.368 38.5001C104.295 38.2958 104.258 38.0499 104.258 37.7641C104.258 37.4532 104.294 37.1955 104.363 36.9911C104.433 36.7868 104.526 36.6239 104.642 36.5025C104.757 36.381 104.892 36.2951 105.044 36.2463C105.197 36.1974 105.352 36.1737 105.511 36.1737C105.669 36.1737 105.825 36.2033 105.977 36.2611C106.13 36.3188 106.265 36.4121 106.385 36.5395C106.503 36.6668 106.599 36.8312 106.672 37.0326C106.744 37.234 106.781 37.4769 106.781 37.7641C106.781 38.0751 106.746 38.3328 106.676 38.5371H106.678Z"
      fill="#FEFEFF"
    />
    <path
      d="M110.66 35.5518C110.349 35.5518 110.075 35.6376 109.836 35.8079C109.598 35.9782 109.428 36.2004 109.324 36.4758L109.186 35.6169H108.582V39.9143H109.377V37.6931C109.377 37.462 109.41 37.2562 109.474 37.0755C109.537 36.8964 109.626 36.7453 109.739 36.6224C109.851 36.501 109.983 36.4092 110.131 36.3485C110.279 36.2877 110.443 36.2566 110.62 36.2566C110.741 36.2566 110.846 36.2685 110.935 36.2937C111.024 36.3174 111.104 36.3485 111.178 36.3855L111.333 35.6821C111.248 35.6451 111.154 35.6154 111.051 35.5903C110.947 35.5666 110.815 35.5532 110.657 35.5532L110.66 35.5518Z"
      fill="#FEFEFF"
    />
    <path
      d="M116.657 37.5369H117.745V39.1362C117.587 39.197 117.424 39.2399 117.256 39.2651C117.089 39.2888 116.889 39.3021 116.658 39.3021C116.048 39.3021 115.576 39.1096 115.241 38.726C114.906 38.3425 114.737 37.7813 114.737 37.0438C114.737 36.6173 114.792 36.259 114.902 35.9702C115.011 35.6814 115.159 35.446 115.346 35.2668C115.533 35.0876 115.747 34.9573 115.99 34.8788C116.235 34.7989 116.489 34.7604 116.759 34.7604C117.009 34.7604 117.242 34.784 117.458 34.8329C117.674 34.8818 117.895 34.9573 118.121 35.061L118.323 34.402C118.09 34.2806 117.84 34.1947 117.569 34.1458C117.298 34.0969 116.994 34.0732 116.66 34.0732C116.251 34.0732 115.873 34.1369 115.525 34.2658C115.177 34.3931 114.88 34.5827 114.629 34.8329C114.379 35.0832 114.182 35.3942 114.04 35.7658C113.896 36.1375 113.825 36.564 113.825 37.0453C113.825 37.5266 113.898 37.9501 114.044 38.3159C114.191 38.6816 114.392 38.9896 114.649 39.2399C114.905 39.4902 115.204 39.6782 115.549 39.8071C115.894 39.9359 116.263 39.9996 116.66 39.9996C117.056 39.9996 117.421 39.967 117.72 39.9033C118.019 39.8396 118.29 39.7582 118.534 39.6605V36.8809H116.66V37.5399L116.657 37.5369Z"
      fill="#FEFEFF"
    />
    <path
      d="M121.741 35.5518C121.43 35.5518 121.156 35.6376 120.917 35.8079C120.679 35.9782 120.509 36.2004 120.405 36.4758L120.267 35.6169H119.663V39.9143H120.458V37.6931C120.458 37.462 120.491 37.2562 120.555 37.0755C120.618 36.8964 120.707 36.7453 120.82 36.6224C120.932 36.501 121.064 36.4092 121.212 36.3485C121.36 36.2877 121.525 36.2566 121.701 36.2566C121.822 36.2566 121.927 36.2685 122.016 36.2937C122.105 36.3174 122.185 36.3485 122.259 36.3855L122.415 35.6821C122.329 35.6451 122.235 35.6154 122.132 35.5903C122.028 35.5666 121.896 35.5532 121.738 35.5532L121.741 35.5518Z"
      fill="#FEFEFF"
    />
    <path
      d="M126.198 36.1011C126.011 35.9175 125.792 35.7813 125.539 35.6895C125.286 35.5977 125.01 35.5518 124.711 35.5518C124.412 35.5518 124.135 35.6021 123.879 35.7028C123.623 35.8035 123.399 35.9501 123.206 36.1411C123.014 36.3322 122.863 36.5691 122.753 36.849C122.644 37.1289 122.589 37.4487 122.589 37.8086C122.589 38.1684 122.642 38.4749 122.749 38.7459C122.855 39.0169 123.002 39.245 123.187 39.4316C123.372 39.6181 123.593 39.7573 123.846 39.8521C124.099 39.9469 124.375 39.9943 124.674 39.9943C124.973 39.9943 125.25 39.9439 125.506 39.8432C125.762 39.7425 125.986 39.5945 126.178 39.399C126.371 39.2035 126.522 38.9651 126.632 38.6808C126.741 38.3979 126.796 38.0766 126.796 37.7167C126.796 37.3569 126.743 37.0504 126.636 36.7794C126.529 36.5084 126.383 36.2818 126.198 36.0982V36.1011ZM125.85 38.5371C125.78 38.7415 125.687 38.9059 125.571 39.0303C125.456 39.1546 125.321 39.2435 125.169 39.2953C125.016 39.3472 124.86 39.3723 124.702 39.3723C124.544 39.3723 124.388 39.3427 124.236 39.2805C124.083 39.2198 123.948 39.125 123.828 38.9977C123.71 38.8703 123.614 38.703 123.54 38.5001C123.467 38.2958 123.43 38.0499 123.43 37.7641C123.43 37.4532 123.466 37.1955 123.535 36.9911C123.605 36.7868 123.698 36.6239 123.814 36.5025C123.929 36.381 124.064 36.2951 124.216 36.2463C124.369 36.1974 124.524 36.1737 124.683 36.1737C124.841 36.1737 124.997 36.2033 125.149 36.2611C125.302 36.3188 125.437 36.4121 125.556 36.5395C125.675 36.6668 125.771 36.8312 125.844 37.0326C125.916 37.234 125.953 37.4769 125.953 37.7641C125.953 38.0751 125.918 38.3328 125.848 38.5371H125.85Z"
      fill="#FEFEFF"
    />
    <path
      d="M131.999 38.3232L131.797 39.2828H131.762L131.569 38.3232L130.811 35.6177H129.942L129.201 38.3232L129 39.2828H128.963L128.798 38.3232L128.067 35.6177H127.208L128.533 39.9136H129.403L130.152 37.2807L130.371 36.2204L130.581 37.2807L131.313 39.9136H132.228L133.534 35.6177H132.712L131.999 38.3232Z"
      fill="#FEFEFF"
    />
    <path
      d="M136.304 39.2138C136.158 39.2405 136.025 39.2553 135.902 39.2553C135.731 39.2553 135.592 39.2183 135.485 39.1457C135.379 39.0731 135.326 38.9295 135.326 38.7163V36.221H136.587V35.6183H135.326V34.2471H134.53V35.6183H133.891V36.221H134.53V38.8273C134.53 39.1812 134.628 39.4507 134.824 39.6359C135.019 39.821 135.33 39.9143 135.756 39.9143C135.964 39.9143 136.162 39.8965 136.35 39.8595C136.54 39.8224 136.695 39.781 136.817 39.7321L136.689 39.119C136.58 39.1561 136.451 39.1872 136.306 39.2153L136.304 39.2138Z"
      fill="#FEFEFF"
    />
    <path
      d="M141.255 36.3929C141.197 36.2226 141.111 36.0746 140.999 35.9502C140.886 35.8258 140.741 35.728 140.565 35.657C140.387 35.5874 140.181 35.5518 139.943 35.5518C139.651 35.5518 139.382 35.6096 139.139 35.7251C138.895 35.8406 138.672 35.9872 138.471 36.1634V33.4209H137.667V39.9129H138.471V36.8046C138.678 36.6151 138.887 36.47 139.098 36.3663C139.308 36.2626 139.517 36.2108 139.724 36.2108C139.998 36.2108 140.202 36.2848 140.337 36.4344C140.47 36.584 140.538 36.8224 140.538 37.1526V39.9144H141.342V36.9527C141.342 36.7513 141.313 36.5662 141.255 36.3944V36.3929Z"
      fill="#FEFEFF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_667_4353"
        x1="19.9986"
        y1="39.9959"
        x2="19.9986"
        y2="9.99854"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.21" stopColor="#A91C8B" stopOpacity="0.1" />
        <stop offset="0.25" stopColor="#A91C8B" stopOpacity="0.29" />
        <stop offset="0.3" stopColor="#A91C8B" stopOpacity="0.48" />
        <stop offset="0.35" stopColor="#A91C8B" stopOpacity="0.64" />
        <stop offset="0.41" stopColor="#A91C8B" stopOpacity="0.78" />
        <stop offset="0.48" stopColor="#A91C8B" stopOpacity="0.88" />
        <stop offset="0.57" stopColor="#A91C8B" stopOpacity="0.95" />
        <stop offset="0.69" stopColor="#A91C8B" stopOpacity="0.99" />
        <stop offset="1" stopColor="#A91C8B" />
      </linearGradient>
    </defs>
  </svg>
)

export const MenuButtonIcon = () => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_311_5737)">
      <rect
        x="5"
        y="1"
        width="40"
        height="40"
        rx="8"
        fill="url(#paint0_linear_311_5737)"
      />
      <path
        d="M16 26.4986H23.5H16ZM16 15.4996H33H16Z"
        fill="url(#paint1_linear_311_5737)"
      />
      <path
        d="M16 26.4986H23.5M16 15.4996H33M16 20.7482H28"
        stroke="#FEFEFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_311_5737"
        x="0"
        y="0"
        width="50"
        height="50"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_311_5737"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_311_5737"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_311_5737"
        x1="45"
        y1="42.5217"
        x2="4.99078"
        y2="1.00888"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#171031" />
        <stop offset="1" stopColor="#281D52" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_311_5737"
        x1="33"
        y1="15.0811"
        x2="23.1142"
        y2="30.9348"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#171031" />
        <stop offset="1" stopColor="#281D52" />
      </linearGradient>
    </defs>
  </svg>
)

export const EarnXText = () => (
  <svg
    width="98"
    height="20"
    viewBox="0 0 98 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.8514 11.5767C18.5818 11.5767 18.7422 11.0831 18.7422 10.0958C18.7422 9.10846 18.5818 8.61325 17.8514 8.61325H3.02619V5.10161C3.02619 3.89473 4.19103 2.96192 6.86331 2.96192H10.1756C10.8842 2.96192 11.043 2.46827 11.043 1.48096C11.043 0.493654 10.8826 0 10.1756 0H6.77143C2.27093 0 0.00976562 1.67406 0.00976562 5.10317V14.7894C0.00976562 18.192 2.27093 19.8925 6.77143 19.8925H17.7829C18.5132 19.8925 18.6736 19.3709 18.6736 18.4116C18.6736 17.4523 18.5132 16.9306 17.7829 16.9306H6.86331C4.19103 16.9306 3.02619 15.9698 3.02619 14.7909V11.5814H17.8514V11.5767Z"
      fill="#FEFEFF"
    />
    <path
      d="M34.4787 4.3884H32.2393C31.5541 4.3884 31.3937 4.85402 31.3937 5.78838C31.3937 6.72274 31.5541 7.16033 32.2393 7.16033H34.3868C36.9454 7.16033 38.0417 7.81906 38.0417 8.86087V8.8889H28.2636C23.9687 8.8889 21.7979 10.4524 21.7979 13.6635V15.118C21.7979 18.301 23.9687 19.8926 28.2636 19.8926H34.4771C38.7721 19.8926 40.9413 18.301 40.9413 15.118V9.16454C40.9413 5.95501 38.7705 4.38995 34.4771 4.38995L34.4787 4.3884ZM38.0417 15.1164C38.0417 16.2143 36.9454 17.1191 34.3868 17.1191H28.3555C25.7969 17.1191 24.7006 16.2143 24.7006 15.1164V13.5529C24.7006 12.4286 25.7969 11.5503 28.3555 11.5503H38.0417V15.1164Z"
      fill="#FEFEFF"
    />
    <path
      d="M52.1663 4.38837H50.3848C46.5695 4.38837 44.4688 5.9799 44.4688 9.13492V18.7106C44.4688 19.7539 44.9484 20 45.9077 20C46.8669 20 47.3699 19.7524 47.3699 18.7106V9.13492C47.3699 7.87198 48.1237 7.15875 50.3848 7.15875H52.1663C52.8515 7.15875 52.9886 6.69157 52.9886 5.78679C52.9886 4.88202 52.8515 4.38681 52.1663 4.38681V4.38837Z"
      fill="#FEFEFF"
    />
    <path
      d="M67.461 4.3884H62.4808C58.1859 4.3884 56.0166 5.95189 56.0166 9.16298V18.7106C56.0166 19.754 56.4962 20 57.4555 20C58.4148 20 58.9178 19.7524 58.9178 18.7106V9.16298C58.9178 8.03863 60.0141 7.16033 62.5727 7.16033H67.3706C69.9292 7.16033 71.0256 8.03863 71.0256 9.16298V18.7106C71.0256 19.754 71.5052 20 72.4645 20C73.4238 20 73.9267 19.7524 73.9267 18.7106V9.16298C73.9267 5.95345 71.7559 4.3884 67.461 4.3884Z"
      fill="#FEFEFF"
    />
    <path
      d="M97.2359 17.5317L89.7891 10.0413L97.1674 2.46827C97.7389 1.86405 97.8978 1.618 97.8978 1.12435C97.8978 0.109009 97.1441 0 96.4355 0C95.727 0 95.2925 0.109009 94.9047 0.493654L87.6852 7.92961L80.3287 0.493654C79.9627 0.109009 79.5983 0 78.8898 0C78.0208 0 77.4042 0.165071 77.4042 1.12435C77.4042 1.618 77.5645 1.86561 78.1578 2.46827L85.4225 9.82169L77.9071 17.5317C77.3356 18.136 77.1768 18.382 77.1768 18.8757C77.1768 19.891 77.9305 20 78.6842 20C79.3461 20 79.7587 19.9175 80.1699 19.5063L87.5264 11.9333L95.0651 19.5063C95.4762 19.9175 95.8189 20 96.4822 20C97.3496 20 97.9897 19.863 97.9897 18.8757C97.9897 18.382 97.8293 18.1344 97.2359 17.5317Z"
      fill="#FEFEFF"
    />
  </svg>
)
